<template>
  <div class="productionModel">
      <el-dialog
		:title="$t('other.a1420')"
		:visible.sync="publishFailedDia"
        :close-on-click-modal="false"
		width="50%"
		>
		<div >
            <el-table
                :data="userInfoProduct"
                size="mini"
                border
                :key="itemkey"
               >
                <el-table-column :label="$t('other.a89')" >
                    <template slot-scope="props">
                       <span >{{props.row.time}}</span>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('other.a1421')" >
                    <template slot-scope="props">
                       <span >{{props.row.country}}</span>
                    </template>
                </el-table-column>
                <el-table-column  :label="$t('other.a33')" width="280px">
                    <template slot-scope="props" >
                      
                       <span style="margin:0 2px"><el-button size="mini" :type="!props.row.default ? 'primary': 'danger'"  @click="publishAgine(props.row)">{{$t('other.a1422')}}</el-button></span>
                       <span style="margin:0 2px"><el-button size="mini" type="info"  @click="deleItem(props.$index)">{{$t('other.a273')}}</el-button></span>
                    </template>
                </el-table-column>
              
            </el-table>
        </div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="publishFailedDia = false">{{$t('other.a5')}}</el-button>
			
		</span>
		</el-dialog>
      <el-dialog
		:title="$t('other.a261')"
		:visible.sync="formulaDia"
        :close-on-click-modal="false"
		width="50%"
		>
        <div>
            <p class="tips">{{$t('other.a262')}}</p>
            <p class="tips">{{$t('other.a263')}}</p>
            <p class="tips">{{$t('other.a264')}} </p>
        </div>
        <div >
            <el-button size="mini" type="primary" @click="addNewFormula()">{{$t('other.a265')}}</el-button>
        </div>
		<div style="margin-top:20px;">
            <el-table
                :data="formulaList"
                size="mini"
                border
                :key="itemkey"
               >
                <el-table-column :label="$t('other.a30')" >
                    <template slot-scope="props">
                       <span >{{$t('other.a266')}}{{props.row.id}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a267')" >
                    <template slot-scope="props">
                       <span v-show="!props.row.checked">{{props.row.outboundfee}}</span>
                       <el-input size="mini" v-show="props.row.checked" v-model="props.row.outboundfee" placeholder=""></el-input>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a268')" >
                    <template slot-scope="props">
                       <span v-show="!props.row.checked">{{props.row.rate}}</span>
                       <el-input size="mini" v-show="props.row.checked" v-model="props.row.rate" placeholder=""></el-input>
                    </template>
                </el-table-column>
                 <el-table-column :label="$t('other.a269')" >
                    <template slot-scope="props">
                       <span >{{props.row.country}}</span>
                       
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a270')" >
                    <template slot-scope="props">
                       <span v-show="!props.row.checked">{{props.row.profit}}</span>
                       <el-input style="width:80px" size="mini" v-show="props.row.checked" v-model="props.row.profit" placeholder=""></el-input>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a271')" >
                    <template slot-scope="props">
                       <span v-show="!props.row.checked">{{props.row.discount}} off</span>
                       <el-input style="width:80px" size="mini" v-show="props.row.checked" v-model="props.row.discount" placeholder=""></el-input>
                    </template>
                </el-table-column>
                <el-table-column  :label="$t('other.a33')" width="280px">
                    <template slot-scope="props" >
                       <span style="margin:0 2px"><el-button size="mini" :type="!props.row.default ? 'primary': 'danger'" @click="setDefault(props.row,props.$index)">{{$t('other.a272')}}</el-button></span>
                       <span style="margin:0 2px" v-show="!props.row.checked"><el-button size="mini" type="primary" @click="props.row.checked=true">{{$t('other.a93')}}</el-button></span>
                       <span style="margin:0 2px" v-show="!props.row.checked"><el-button size="mini" type="primary" @click="updateRule(props.row,props.$index,0)">{{$t('other.a312')}}</el-button></span>
                       <span style="margin:0 2px" v-show="props.row.checked"><el-button size="mini" type="warning" @click="updateRule(props.row,props.$index,1)">{{$t('other.a38')}}</el-button></span>
                       <span style="margin:0 2px" v-show="props.row.checked"><el-button size="mini" type="info" @click="props.row.checked=false">{{$t('other.a146')}}</el-button></span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="formulaDia = false">{{$t('other.a5')}}</el-button>
		</span>
		</el-dialog>

      <el-dialog
		:title="$t('other.a275')"
		:visible.sync="replaceImg"
		width="30%"
		>
		<div style="text-align: center">
           <el-input v-model="shopeeUrl" :placeholder="$t('other.a276')"></el-input>
		</div>
        <div style="margin-top:20px" v-if="showPersoun">
            <el-progress :text-inside="true" :stroke-width="18" :percentage="percentage"></el-progress>
        </div>

        <div style="margin-top:20px" v-if="showPersoun">
            <span v-if="percentage !== 100"><i class="el-icon-loading"></i>{{$t('other.a277')}}</span>
            <span v-if="percentage == 100">{{$t('other.a278')}}</span>
        </div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="replaceImg = false">{{$t('other.a5')}}</el-button>
			<el-button type="primary" @click="getOnlineProduct()">{{$t('other.a279')}}</el-button>
		</span>
		</el-dialog>

      <el-dialog
		:title="$t('other.a1423')"
		:visible.sync="updatPic"
		width="30%"
		>
		<div style="text-align: center">
            <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :headers="token"
            :http-request="handleUploadHttpRequest"
            :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">{{$t('other.a281')}}</div>
            </el-upload>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="updatPic = false">{{$t('other.a106')}}</el-button>
			<el-button type="primary" @click="imgConfirm()">{{$t('other.a279')}}</el-button>
		</span>
		</el-dialog>
        <el-dialog :title="$t('other.a1424')" :visible.sync="dialogVisible"  width="90%">
			<div style="width: 100%;">
				<div>
					<div style="padding-bottom: 10px;">
                        {{$t('other.a653')}}：
                        <el-select v-model="storeValue" @change="getStoreItem()" :placeholder="$t('other.a50')">
                            <el-option
                            v-for="item in wareOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>

                        <el-select style="margin:0 10px" v-model="singleValue" @change="getStoreItem()" :placeholder="$t('other.a50')">
                            <el-option
                            v-for="item in singleType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
						<el-input style="width: 30%;" v-model="searchCuscode" :placeholder="$t('other.a1425')" clearable></el-input>
						<el-button type="primary" @click="search()">{{$t('other.a27')}}</el-button>
					</div>
				</div>
				<div>
					<el-table size="mini" :data="tableList" height="500px" style="width: 100%" border >
						<el-table-column :label="$t('other.a29')" width="80">
                            <template scope="scope">
                                <el-radio :label="scope.$index"  v-model="radio2" @change.native="getCurrentRow(scope.row)">&nbsp;</el-radio>
                            </template>
						</el-table-column>
						<el-table-column prop="outTradeNo" :label="$t('other.a66')" width="150">
							<template slot-scope="props">
								<el-popover placement="top-start" title="" trigger="hover">
									<img :src="props.row.image" alt="" style="width: 300px;height: 300px">
									<img slot="reference" :src="props.row.image" style="width: 100px;height: 100px">
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a735')" width="180">
							<template slot-scope="props">
								<span>{{props.row.itemSku}}</span>
							</template>
						</el-table-column>
                        <el-table-column :label="$t('other.a1426')" >
							<template slot-scope="props">
								<el-table size="mini" :data="props.row.storeItems" >
                                    <el-table-column prop="cusCode" label="cusCode"></el-table-column>   
                                    <el-table-column prop="skuName" :label="$t('other.a736')"></el-table-column> 
                                    <el-table-column prop="stock" :label="$t('other.a1171')"></el-table-column> 
                                </el-table>    
							</template>
						</el-table-column>
					</el-table>
					<div style="width: 100%;display: flex;justify-content: flex-end;margin-top:15px">
						<el-pagination @size-change="handleSizeChangeStore" @current-change="handleCurrentChangeStore" :current-page="currentPage4"
						 :page-sizes="[15, 30, 50, 100]" :page-size="15" layout="total, sizes, prev, pager, next, jumper" :total="tableCount">
						</el-pagination>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible=false">{{$t('other.a106')}}</el-button>
                <el-button type="primary" @click="submitPsku()">{{$t('other.a274')}}</el-button>
			</span>
		</el-dialog>

        <el-dialog
        :title="$t('other.a1427')"
        :visible.sync="waterDialog"
        width="30%"
        >
        <div class="waterWrapper">
            <div :class="{'waterProduct':true, 'active':imgUrl==item.watermarkUrl}" @click="handlePic(item)" v-for="(item,index) in imgList" :key="index">
                <img  :src="item.watermarkUrl" />
                <div class="dexlet" @click="deleteWaterImg(item,index)">x</div>
            </div>
            <div>
                <el-upload 
                action=""
                class="uploaImg"
                
                :http-request="uploaWaterImg"
                :on-success="handlePictureSuccess"
                :show-file-list="false">
                
                <i class="el-icon-plus"></i>
                </el-upload>
            </div>

        </div>

            <div v-if="imageLength"  class="okting">
            <el-progress :text-inside="true" :stroke-width="18" :percentage="percentage"></el-progress>
            <div class="olkg">{{percentage == 100 ? $t('other.a119') : $t('other.a1430')}}</div>
            </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="waterDialog = false">{{$t('other.a5')}}</el-button>
            <el-button type="primary" @click="addWaterImg(0)">{{$t('other.a1431')}}</el-button>
            <el-button type="primary" @click="addWaterImg(1)">{{$t('other.a1432')}}</el-button>
        </span>
        </el-dialog>


        <div class="basic_info">
            <div style="padding:15px 0">
                <el-steps  :active="active" finish-status="success">
                <el-step :title="$t('other.a238')"></el-step>
                <el-step :title="$t('other.a1428')"></el-step>
                <el-step :title="$t('other.a1355')"></el-step>
                </el-steps>
            </div>
            <div class="title">
                <el-tabs v-model="activeName"  @tab-click="getCategory()" >
                    <el-tab-pane :label="ccp.label" :name="ccp.value" v-for="(ccp,index) in sitelist" :key="index"></el-tab-pane>
                </el-tabs>
            </div>
           
        </div>

        <div v-show=" activeName !== 'ROOT'  && activeName !== 'DXS'" class="basic_info">
            <div class="title" ref="shopAndCategory">{{$t('other.a1377')}}</div>
            <div class="basic_detail">
                <el-form  :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item  :label="$t('other.a1359')" prop="name">
                         <el-select style="width:100%" v-model="targetShopId" @change="getShopId()"   :placeholder="$t('other.a50')">
                            <el-option
                            v-for="item in shopOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1360')" prop="name">
                         <el-select style="width:160px" v-model="ruleForm.status"  :placeholder="$t('other.a50')">
                            <el-option
                            v-for="item in statusOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1285')"  prop="name">
                        <div v-clickOutSide="handleClose">
                            <el-input v-model="categories" :placeholder="$t('other.a1285')" @focus="showCaetgory=!showCaetgory"></el-input>
                            <div v-if="showCaetgory" class="cateGory_wrapper"  >
                                <ul  class="first_wrapper">
                                    <div class="category_title">{{$t('other.a482')}}</div>
                                    <li class="first_category active" v-for="(item,index) in categoryList" :key="index" @click="cateGory(item,1)">
                                        <span>{{item.categoryName}} </span>
                                    </li>
                                </ul>
                                <ul v-if="secondCategory.length"  class="second_wrapper">
                                    <div class="category_title">{{$t('other.a483')}}</div>
                                    <li class="second_category  active" v-for="(itemTwo,indexOne) in secondCategory" :key="indexOne" @click="cateGory(itemTwo,2)">
                                    <span> {{itemTwo.categoryName}} </span>
                                    </li>
                                </ul>
                                <ul v-if="thiryCategory.length"  class="three_wrapper">
                                    <div class="category_title">{{$t('other.a484')}}</div>
                                    <li class="three_category  active" v-for="(itemThree,indexOne) in thiryCategory" :key="indexOne" @click="cateGory(itemThree,3)">
                                        <span>{{itemThree.categoryName}}</span>
                                    </li>
                                </ul>

                                <ul v-if="fourCategory.length"  class="four_wrapper">
                                    <div class="category_title"> {{$t('other.a1378')}}</div>
                                    <li class="four_category  active" v-for="(itemfour,indexOne) in fourCategory" :key="indexOne" @click="cateGory(itemfour,4)">
                                        {{itemfour.categoryName}}
                                    </li>
                                </ul>
                                <ul v-if="fiveCategory.length"  class="five_wrapper">
                                    <div class="category_title"> {{$t('other.a1379')}}</div>
                                    <li class="five_category  active" v-for="(itemfive,indexOne) in fiveCategory" :key="indexOne" @click="cateGory(itemfive,5)">
                                        {{itemfive.categoryName}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item  :label="$t('other.a1361')">
                            <div class="ojkng">
                                <div style="display:flex;" v-for="(item,index) in attributes" :key="index"  :prop="item.is_mandatory ? 'isMandatory' : 'notMandatory' " >
                                    <div class="ihbkg">
                                    <i v-if="item.is_mandatory" style="color:red;font-size:20px">*</i>{{item.attribute_name}}：
                                        <div style="display:flex;align-items: center;">
                                            <el-select style="width:250px" class="attribute"  ref="searchSelect" filterable v-if="item.input_type == 'COMBO_BOX'" v-el_selectLoadmore:addRangeNumber="loadMore()" @input.native="findItem(item,index)"  v-model="item.userValue" filterable  @change="pushAttribute()"  :placeholder="$t('other.a50')">
                                                <el-option
                                                v-for="item in item.options.slice(0,rangeNumber)"
                                                :key="item"
                                                :label="item"
                                                :value="item">
                                                </el-option>
                                            </el-select>
                                           
                                            <el-select style="width:120px"  ref="searchSelect" filterable v-if="item.input_type == 'COMBO_BOX' && item.unit_list"  v-el_selectLoadmore:addRangeNumber="loadMore()" @input.native="findItem(item,index)"  v-model="item.unit" filterable  @change="pushAttribute()"  :placeholder="$t('other.a1362')">
                                                <el-option
                                                v-for="item in item.unit_list"
                                                :key="item"
                                                :label="item"
                                                :value="item">
                                                </el-option>
                                            </el-select>
                                            
                                            <el-select style="width:180px" class="attribute" ref="searchSelect" v-if="item.input_type == 'DROP_DOWN'" v-el_selectLoadmore:addRangeNumber="loadMore()" @input.native="findItem(item,index)"  v-model="item.userValue" filterable  @change="pushAttribute()"  :placeholder="$t('other.a50')">
                                                <el-option
                                                v-for="item in item.options.slice(0,rangeNumber)"
                                                :key="item"
                                                :label="item"
                                                :value="item">
                                                </el-option>
                                            </el-select>
                                           
                                            <el-select style="width:180px" ref="searchSelect" v-if="item.input_type == 'DROP_DOWN' && item.unit_list" v-el_selectLoadmore:addRangeNumber="loadMore()" @input.native="findItem(item,index)"  v-model="item.unit" filterable  @change="pushAttribute()"  :placeholder="$t('other.a1362')">
                                                <el-option
                                                v-for="item in item.unit_list"
                                                :key="item"
                                                :label="item"
                                                :value="item">
                                                </el-option>
                                            </el-select>


                                            <el-input style="width:180px"  v-if="item.input_type == 'TEXT_FILED' " class="attribute"   v-model="item.userValue" :placeholder="$t('other.a298')" @change="pushAttribute()"></el-input>

                                            <el-select style="width:120px" ref="searchSelect" v-if="item.input_type == 'TEXT_FILED' && item.unit_list" v-el_selectLoadmore:addRangeNumber="loadMore()" @input.native="findItem(item,index)"  v-model="item.unit" filterable  @change="pushAttribute()"  :placeholder="$t('other.a1362')">
                                                <el-option
                                                v-for="item in item.unit_list"
                                                :key="item"
                                                :label="item"
                                                :value="item">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                    </el-form-item>
                     <el-form-item  :label="$t('other.a1363')" >
                        <div>
                          <el-radio v-model="ruleForm.condition" label='NEW'>{{$t('other.a1380')}}</el-radio>
                          <el-radio v-model="ruleForm.condition" label="USED">{{$t('other.a1381')}}</el-radio>
                        </div>
                        
                    </el-form-item>

                   
                </el-form>

                
            </div>
        </div>

        <div class="basic_info" ref="bascInfo">
            <div class="title">{{$t('other.a1239')}}</div>
            <div class="basic_detail">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1364')" v-if="activeName == 'DXS'" prop="name">
                        <el-select style="width:250px" ref="searchSelect"    v-model="ruleForm.country"   :placeholder="$t('other.a644')">
                            <el-option
                            v-for="item in countryOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item :label="$t('other.a1365')" v-if="ruleForm.sourceUrl" prop="name">
                        <el-input
                        type="textarea"
                        autosize
                        :placeholder="$t('other.a319')"
                        v-model="ruleForm.sourceUrl">
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a179')" prop="name">
                        <div class="okntk">
                            <el-input
                            type="textarea"
                            autosize
                            :placeholder="$t('other.a319')"
                            v-model="ruleForm.name">
                            </el-input>
                            <span class="mhbm">{{ruleForm.name.length}}/120</span>
                        </div>
                    </el-form-item>
                     <el-form-item :label="$t('other.a318')" prop="description">
                        <el-input
                        type="textarea"
                        :autosize="{ maxRows: 8}"
                        :placeholder="$t('other.a319')"
                        v-model="ruleForm.description">
                        </el-input>
                    
                    </el-form-item>
                    
                </el-form>
            </div>
        </div>

        <div class="basic_info">
            <div class="title sined" ref="photo">
                <span>{{$t('other.a1265')}}</span>
                <span  style="margin-left:30px">
                    <el-upload 
                    class="obikg"
                    action=""
                    :http-request="handleUploadHttpRequest"
                    :show-file-list="false">
                    <el-button id="initSlide" size="medium" type="primary">{{$t('other.a1433')}}</el-button>
                    </el-upload>
                </span>
                <span  style="margin-left:30px"><el-button  size="medium" type="primary" @click="randomNum()">{{$t('other.a290')}}</el-button></span>
                <span  style="margin-left:30px"><el-button  size="medium" type="primary" @click="getWaterImg()">{{$t('other.a291')}}</el-button></span>
                <span  style="margin-left:30px"><el-button  size="medium" type="primary" @click="replaceImg=true">{{$t('other.a292')}}</el-button></span>
                <span  style="margin-left:30px">{{$t('other.a930')}}</span>
            </div>
            <div class="basic_detail">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1242')" prop="name">
                        <draggable
                        class=""
                        v-model="ruleForm.images"
                        tag='ul'
                        v-bind="dragOptions"
                        @start="ruleForm.drag = true"
                        @end="ruleForm.drag = false"
                        >
                        <span v-for="(item,index) in ruleForm.images" :key="index"  :class="{'listitem':true,}"   @mouseenter="indexOne=index" @mouseleave="indexOne =-1">
                      
                            <img v-show="item.image"  :src="item.image"  class="pic_box">
                            <div v-show="item.image" :class="{'delete':true,'deleteActive':indexOne == index}" @click.stop="deleteImg(index)">{{$t('other.a312')}}</div>
                            <span class="pic_desc">{{index == 0 ? $t('other.a1266') : $t('other.a66')+index}}</span>
                        </span>
                        </draggable>
                    </el-form-item>
                    
                </el-form>
            </div>
        </div>
        <div class="basic_info" ref="variations">
            <div class="title">{{$t('other.a1271')}}</div>
            <div class="basic_detail">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1273')" prop="variation" >
                       <!-- <el-radio v-model="radio" label="1">{{$t('other.a251')}}</el-radio> -->
                       <el-radio   v-model="radio" label="2">{{$t('other.a1272')}}</el-radio>
                    </el-form-item>
                     <el-form-item v-show=" radio == '2'"  :label="$t('other.a1366')" >
                        <div>
                            <el-input style="width:250px" type="text" v-model="addAttribute" :placeholder="$t('other.a1367')"></el-input>
                            <el-button style="margin:0 10px" type="primary" @click="addAttibuteItem()">{{$t('other.a1382')}}</el-button>
                        </div>
                        <div class="attribute" v-if="ruleForm.tiers.length > 0" v-for="(item,index) in ruleForm.tiers" :key="index">
                            <div class="fist_title_wrapper">
                                <div>
                                    <span v-show="!item.checked02" class="fist_title">{{item.name}}</span>
                                    <input v-show="item.checked02" v-model="item.name" placeholder="" />
                                    <i v-show="!item.checked02" class="el-icon-edit" @click="vkfb(item,index)"></i>
                                    <i v-show="item.checked02" class="el-icon-check" @click="confirmvkfb(item,index)"></i>
                                </div>
                                <span style="color:#409EFF;cursor: pointer" @click="delAttItem(index)">{{$t('other.a312')}}</span>
                            </div>
                            <div>
                                <span class="category_item" v-for="(firstItem,index02) in item.listItem" :key="index02">
                                    <span v-show="!firstItem.checked02">{{firstItem.name}}</span>
                                    <input class="kvnnf" v-show="firstItem.checked02" v-model="firstItem.name" placeholder="" />
                                    <i v-show="!firstItem.checked02" class="el-icon-edit" @click="onhv(firstItem,index,index02)"></i>
                                    <i v-show="firstItem.checked02" class="el-icon-check" @click="fixAttr(firstItem,index,index02)"></i>
                                    <i v-show="firstItem.checked02" class="el-icon-circle-close" @click="delAttr(index,index02)"></i>
                                </span>
                                
                            </div>
                        <!-- <div>
                                <el-input style="width:150px" size="mini" type="text" v-model="item.firstCategory" :placeholder="$t('other.a1247')"></el-input>
                                <el-button style="margin:0 10px" size="mini" @click.stop="addOtherspp(index)">{{$t('other.a1081')}}</el-button>
                        </div> -->
                        </div>
                    </el-form-item>

                    <!-- <el-form-item v-show=" activeName !== 'ROOT'" width="250"  label="商品折扣%" prop="itemSku">
                        <el-input style="width:350px"  v-model="ruleForm.price" :placeholder="$t('other.a298')"></el-input>
                    </el-form-item> -->


                     <el-form-item v-show=" activeName !== 'ROOT'" width="250"  :label="$t('other.a1429')" prop="itemSku">
                        <div>
                            <el-input style="width:350px"  v-model="ruleForm.itemSku" :placeholder="$t('other.a298')"></el-input>
                            <!-- <el-button style="margin:0 10px" type="primary" @click="banding(ruleForm.itemSku,ruleForm.storeId)">{{$t('other.a1434')}}</el-button> -->
                            <el-button style="margin:0 10px" type="primary" @click="handleByuser(ruleForm.itemSku,ruleForm.storeId)">{{$t('other.a1435')}}</el-button>
                            <!-- <i v-show="ruleForm.groupId && radio == '1'" class="iconfont icon-gouSolid-copy"></i>
                            <span v-show="ruleForm.groupId && radio == '1'">{{$t('other.a1436')}}：{{ruleForm.itemSku}}</span> -->
                        </div>
                    </el-form-item>
                   
                     <el-form-item :label="$t('other.a1245')" prop="variations">
                         <div v-if="activeName !== 'ROOT' && activeName !== 'DXS'">
                             <el-button type="primary" @click="formulaDia=true">{{$t('other.a1437')}}</el-button>
                             <span v-if="valuation" class="ionkjg">{{$t('other.a2877')}}：{{$t('other.a1252')}}=（{{$t('other.a219')}}+{{valuation.outboundfee}}{{$t('other.a157')}}/{{$t('other.a910')}}）/{{valuation.rate}}（{{$t('other.a268')}}）*{{valuation.profit/100+1}}{{$t('other.a301')}}/{{1-valuation.discount/100}}{{$t('other.a302')}}</span>
                         </div>
                       <el-table
                            v-if="radio == '2'"
                            :data="ruleForm.variations"
                            :key="itemKey"
                            border
                            style="width: 100%;margin-top:15px">
                            <el-table-column prop="outTradeNo" :label="$t('other.a217')" width="130">
                                <template slot-scope="props" >
                                    <div v-if="!ruleForm.tiers[0].images">
                                        <img   class="picBox"  slot="reference" :src="null"   />
                                    </div>
                                    <div v-else>

                                    <div v-if="!ruleForm.tiers[0].images[props.row.tierIndex[0]]" class="rbjg" @click="changePic(props.row,1)"> 
                                        +
                                    </div>   
                                    <div v-else  @mouseenter="showAttrImg=props.$index"  @mouseleave="showAttrImg=-1" class="okblf">
                                    <img   class="picBox"  slot="reference" :src="ruleForm.tiers[0].images[props.row.tierIndex[0]]" style=""  />
                                    <span :class="{'vlkbn':showAttrImg == props.$index}">
                                        <i class="dklng el-icon-edit" style="font-size: 13px" @click="changePic(props.row,1)"> </i>
                                        <i class="dklng el-icon-delete" @click="deleAttrImg(props.$index)"> </i>
                                    </span>
                                    </div>
                                  </div>  
                                </template>
                            </el-table-column>
                   
                            <el-table-column v-if="ruleForm.tiers.length>0" :label="ruleForm.tiers[0].name">
                                 <template slot-scope="props">
                                    <span>{{ruleForm.tiers[0].optionArray[props.row.tierIndex[0]]}}</span>
							    </template>
                            </el-table-column>
                              <el-table-column v-if="ruleForm.tiers.length>1"  :label="ruleForm.tiers[1].name">
                                 <template slot-scope="props">
                                    <span>{{ruleForm.tiers[1].optionArray[props.row.tierIndex[1]]}}</span>
                                    
							    </template>
                            </el-table-column>
                            <el-table-column
                            >
                                <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{getCountryName(activeName)}}{{$t('other.a1438')}}({{getCurrencyCopy(activeName)}})</span>
										 <el-input size="mini" style="width:120px" @blur="setPrice(1)" v-model="priceValue" :placeholder="$t('other.a1248')"></el-input>
								</template>
                                 <template slot-scope="props">
                                     <el-input v-if="!props.row.cost" @blur="getDataType(props.row.price)" v-model="props.row.price" :placeholder="$t('other.a1343')"></el-input>
                                     <el-input v-if="props.row.cost" @blur="getDataType(props.row.price)" v-model="props.row.price" :placeholder="props.row.cost"></el-input>
							     </template>
                            </el-table-column>
                            <el-table-column
                                prop="date"
                                width='200'
                                :label="$t('other.a310')">
                                <template slot-scope="scope"  slot="header">
										 <span style="padding-right:25px">{{$t('other.a310')}}</span>
										 <el-input size="mini" style="width:120px" @blur="setPrice(2)" v-model="stockValue" :placeholder="$t('other.a1248')"></el-input>
								   </template>
                                 <template slot-scope="props">
								    <el-input @blur="props.row.stock=Number(props.row.stock)" v-model="props.row.stock" :placeholder="$t('other.a1249')"></el-input>
							    </template>
                            </el-table-column>
                            <el-table-column
                                prop="date"
                                :label="$t('other.a1251')">
                                 <template slot-scope="props">
                                    <el-input  v-model="props.row.variationSku" :placeholder="$t('other.a1250')"></el-input>
							    </template>
                            </el-table-column>
                             <el-table-column
                                v-if="activeName !== 'ROOT'"
                                prop="date"
                                width="300"
                                :label="$t('other.a1344')">
                                 <template slot-scope="props">
                                    <el-select v-model="props.row.cusCode" :placeholder="$t('other.a50')">
                                        <el-option v-for="item in props.row.options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                                    </el-select>
                                    <!-- <i v-show="props.row.cusCode && props.row.cusCode !== '无法匹配' " class="iconfont icon-gouSolid-copy"></i> -->
							    </template>
                            </el-table-column>
                        </el-table>

                        <div v-if="radio == '1'" class="singSku_wrapper">
                            <div class="singSku">
                                <span>skuName：</span>
                                <el-input class="inputBox" v-model="ruleForm.itemSku" placeholder="sku"></el-input>
                            </div>
                            <div class="singSku">
                                <span>{{$t('other.a831')}}：</span>
                                <el-input class="inputBox" v-model="ruleForm.price" :placeholder="$t('other.a1252')"></el-input>
                            </div>
                            <div class="singSku">
                                <span>{{$t('other.a310')}}：</span>
                                <el-input class="inputBox" v-model="ruleForm.stock" :placeholder="$t('other.a310')"></el-input>
                            </div>
                        </div>
                    </el-form-item>
                    
                </el-form>
            </div>
        </div>

        <div class="basic_info">
            <div class="title" ref="logistic">{{$t('other.a1276')}}</div>
            <div class="basic_detail">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1253')" prop="weight">
                        <el-input @blur="ruleForm.weight=Number(ruleForm.weight)" style="width:250px;margin-right:15px" v-model="ruleForm.weight"></el-input>
                        <span>KG</span>
                    </el-form-item>
                     <el-form-item :label="$t('other.a1254')" prop="name">
                        <el-input @blur="ruleForm.packageLength=Number(ruleForm.packageLength)"  style="width:80px;margin-right:15px" v-model="ruleForm.packageLength" :placeholder="$t('other.a1255')"></el-input>
                        <el-input @blur="ruleForm.packageWidth=Number(ruleForm.packageWidth)" style="width:80px;margin-right:15px" v-model="ruleForm.packageWidth" :placeholder="$t('other.a1256')"></el-input>
                        <el-input @blur="ruleForm.packageHeight=Number(ruleForm.packageHeight)" style="width:80px;margin-right:15px" v-model="ruleForm.packageHeight" :placeholder="$t('other.a1257')"></el-input>
                        <span>CM</span>
                    </el-form-item>

                   

                    <el-form-item v-show=" activeName !== 'ROOT'" :label="$t('other.a619')" prop="name">
                        <div>
                            <el-checkbox v-model="checkedAlllogisctic" @>{{$t('other.a1383')}}</el-checkbox>
                            <el-button style="margin:0 15px" type="primary" @click="syncLogistics()">{{$t('other.a1384')}}</el-button>
                        </div>
                        <div>
                            <el-checkbox v-model="it.enabled" v-for="(it,index12) in logisticeByshop" :key="index12">{{it.logistics_channel_name}}</el-checkbox>
                        </div>
                    </el-form-item>
                    
                </el-form>
            </div>
        </div>

        <div class="basic_info" v-show="activeName=='PRO'">
            <div class="title" ref="logistic">{{$t('other.a1277')}}</div>
            <div class="basic_detail">
                <el-form :model="productDTO"  ref="productDTO" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a1258')" prop="weight">
                        <el-input @blur="productDTO.estimateProfit=Number(productDTO.estimateProfit)" style="width:250px;margin-right:15px" v-model="productDTO.estimateProfit"></el-input>
                       
                    </el-form-item>
                    <el-form-item :label="$t('other.a1259')" prop="weight">
                        <!-- <el-input  style="width:250px;margin-right:15px" v-model="productDTO.isQualityTest"></el-input> -->
                        <el-select v-model="productDTO.isQualityTest" :placeholder="$t('other.a50')">
                            <el-option
                            v-for="item in optionsQue"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1260')" prop="weight">
                        <el-input  style="width:250px;margin-right:15px" v-model="productDTO.productKeyWord"></el-input>
                       
                    </el-form-item>
                     <!-- <el-form-item :label="$t('other.a1346')" prop="weight">
                        <el-input  style="width:250px;margin-right:15px" v-model="productDTO.productStatus"></el-input>
                       
                    </el-form-item> -->
                    <el-form-item :label="$t('other.a1261')" prop="weight">
                        <el-input  style="width:250px;margin-right:15px" v-model="productDTO.salesStatus"></el-input>
                       
                    </el-form-item>
                    <el-form-item :label="$t('other.a1262')" prop="weight">
                        <el-input  style="width:250px;margin-right:15px" v-model="productDTO.purchaseCost"></el-input>
                       
                    </el-form-item>
                   <el-form-item :label="$t('other.a1263')" prop="weight">
                        <!-- <el-input  style="width:250px;margin-right:15px" v-model="productDTO.supplier"></el-input> -->
                       <el-select
                            v-model="productDTO.supplier"
                            :placeholder="$t('other.a1113')" 
                        >
                            <el-option
                            v-for="item in supplierData"
                            :key="item.id"
                            :label="item.supplier"
                            :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1264')" prop="weight">
                        <!-- <el-input  style="width:250px;margin-right:15px" v-model="productDTO.warehouse"></el-input> -->
                       <el-select v-model="productDTO.warehouse" :placeholder="$t('other.a914')" >
                                <el-option
                                v-for="item in warehouseOption"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                >
                                </el-option>
                            </el-select>
                    </el-form-item>
                    
                    
                </el-form>
            </div>
        </div>

        <div class="footer">
            <div>
                
               
            </div>
            <div>
                <!-- <el-button v-if="(activeName == 'ROOT' && !fabuProduct) || addOthers" type="primary" @click="addProducts()" >{{$t('other.a1296')}}</el-button> -->
                <el-button v-if="(activeName == 'ROOT' && !fabuProduct) || addOthers" type="primary" @click="publishAndsave()" >{{$t('other.a1385')}}</el-button>
                <el-button style="margin-left:30px" type="primary" @click="publishFailedDia=true">{{$t('other.a1420')}}</el-button>
                <el-button v-if="fabuProduct" type="info" @click="saveProdcutModel()">{{$t('other.a2878')}}</el-button>
                <el-button v-if="(activeName == 'ROOT' && !fabuProduct) || addOthers" type="primary" @click="saveItem('ruleForm')" >{{$t('other.a1387')}}</el-button>
                <el-button v-if="(activeName == 'ROOT' && !fabuProduct) || addOthers" style="margin-right:60px" type="primary" @click="cancel()">{{$t('other.a106')}}</el-button>
                <!-- <el-button v-if="fabuProduct " style="margin-right:10px" type="info" @click="draftBox()">{{$t('other.a3206')}}</el-button> -->

                 <el-button v-if="fabuProduct"  style="margin-right:10px"  type="danger"  @click="checkImgData()">{{$t('other.a1388')}}</el-button>
                 <!-- <el-button v-if="fabuProduct"  style="margin-right:10px"  type="danger"  @click="updataLink()">更新产品</el-button> -->
                 <el-button v-if="fabuProduct"  style="margin-right:60px"  type="primary" @click="back()">{{$t('other.a605')}}</el-button>

                 

                 
            </div>
        </div>

    
  </div>
</template>

<script>
import api from '../../../api/api'
import axios from 'axios'
import userStoreItemsApi from '../../../api/moudles/userStoreItems'
import originJsonp  from 'jsonp'
import draggable from "vuedraggable"
import md5 from 'js-md5'
import { mapState, mapMutations } from 'vuex'
import { showLoading, hideLoading } from '@/assets/js/loading.js'
import { resolve } from 'path'
import userstoreitemsTabVue from '../overseas/userstoreitemsTab.vue'
import utils from '../../../utils/utils'
import jsonp from '../../../api/jsonp'
export default {
data(){
return{
    shopeeUrl:null,
    changeAttrPic:false,
    replaceImg:false,
    showPersoun:false,
    formulaDia:false,
    publishFailedDia:false,
    supplierData:[],
    imageLength:0,
    percentage:0,
    imgUrl:null,
    warehouseOption:[],
    optionsQue: [{
          value: 'is_quality_test',
          label: this.$t('other.a1280')
        }, {
          value: 'no_quality_test',
          label: this.$t('other.a1281')
        }],
    productDTO :{
  createdTime: "2021-09-13T06:23:16.907Z",
  estimateProfit: 0,
  isQualityTest: "no_quality_test",
  itemSkuType: 1,
  
  
  productAttributes: [
    {
      attributeId: "string",
      attributeName: "string",
      attributeType: 0,
      attributeValue: "string",
      attributeValues: [
        {
          attributeId: "string",
          attributeName: "string",
          attributeValue: "string",
          attributeValueId: "string",
          createdTime: "2021-09-13T06:23:16.912Z",
          productId: "string",
          updatedTime: "2021-09-13T06:23:16.912Z"
        }
      ],
      createdTime: "2021-09-13T06:23:16.912Z",
      productId: "string",
      updateTime: "2021-09-13T06:23:16.912Z"
    }
  ],
  productDescription: "productDescription",
  productId: "productId",
  productKeyWord: "",
  productLogistic: {
    createdTime: "2021-09-13T06:23:16.912Z",
    height: 0,
    length: 0,
    productId: "string",
    updatedTime: "2021-09-13T06:23:16.912Z",
    weight: 0,
    wide: 0
  },
  productName: "productName",
  productPhotoList: [],
  productPrincipal: JSON.parse(localStorage.getItem('userInfo')).userId,
  productSku: "productSku",
  productSkuList: [
    {
      attributeList: [
        {
          attributeId: "string",
          attributeName: "string",
          attributeType: 0,
          attributeValue: "string",
          attributeValues: [
            {
              attributeId: "string",
              attributeValue: "string",
              attributeValueId: "string",
              createdTime: "2021-09-13T06:23:16.912Z",
              productId: "string",
              updatedTime: "2021-09-13T06:23:16.912Z"
            }
          ],
          createdTime: "2021-09-13T06:23:16.912Z",
          skuId: "string",
          updatedTime: "2021-09-13T06:23:16.912Z"
        }
      ],
      skuName: "string",
      createdTime: "2021-09-13T06:23:16.912Z",
      estimatedPurchasePrice: 0,
      inventory: 0,
      productId: "string",
      skuId: "string",
      updatedTime: "2021-09-13T06:23:16.912Z"
    }
  ],
  productStatus: "CREATED",
  productUrl: "",
  imgUrl:null,
  purchaseCost: 0,
  salesStatus: "salesStatus",
  supplier: "",
  updatedTime: "2021-09-13T06:23:16.912Z",
  warehouse: ""
},
    userId:JSON.parse(localStorage.getItem('userInfo')).userId,
    itemKey:0,
    targetIndex:0,
    failedlist:[],
    logisticeByshop:[],
    checkedAlllogisctic:false,
    shoidForLogistics:null,
    rangeNumber:20,
    ruleForm: {
        attributes:[],
        productShops:[],
        categories:null,
        categoryId:0,
        modelId:null,
        name: '',
        images:[],
        drag: false,
        status:'NORMAL',
        packageHeight:'',
        description:'',
        packageLength:'',
        country:'ROOT',
     
        packageWidth:'',
        weight:'',
        hasVariation:false,
        
        variations:[{
            name:'',
            price:'',
            stock:'',
            variationSku:''
        }],
        logistics:[],
        userId:JSON.parse(localStorage.getItem('userInfo')).userId
    },
    rules: {
        name: [
        { required: true, message: this.$t('other.a1282'), trigger: 'blur' },
        { min: 1, max: 255, message: this.$t('other.a1283'), trigger: 'blur' }
        ],
        description: [
        { required: true, message: this.$t('other.a1284'), trigger: 'blur' }
        ],
        categories: [
        { required: true, message: this.$t('other.a1285'), trigger: 'blur' }
        ],
        variation:[
        { required: true, message: this.$t('other.a1286'), trigger: 'blur' }
        ],
        weight:[
        { required: true, message: this.$t('other.a1287'), trigger: 'blur' }
        ],
        variations:[
        { required: true, message: this.$t('other.a1288'), trigger: 'blur' }
        ],
        isMandatory:[
        { required: true, message: this.$t('other.a1289'), trigger: 'blur' }
        ],
        userValue:[
        { required: true, message: this.$t('other.a1282'), trigger: 'blur' },
        ],
        itemSku:[
        { required: true, message: this.$t('other.a1290'), trigger: 'blur' },
        ],
       
    },
    ruleForm1:{
        categories:null
    },


     rules1: {
        categories: [
            { required: true, message: this.$t('other.a1285'), trigger: 'blur' }
        ],
       
    },
    currentPage:-1,
    imageList:'',
    indexOne:-1,
    options:[],
    singleType:[{
        label:this.$t('other.a251'),
        value:true
    },{
        label:this.$t('other.a252'),
        value:false
    }],
    statusOptions:[{
        label:this.$t('other.a1291'),
        value:'NORMAL'
    },{
        label:this.$t('other.a1292'),
        value:'UNLIST'
    }],
    singleValue:true,
    imageUrl:'',
    value:'',
    categories:'',
    targetShopId:null,
    showAttrImg:-1,
    waterDialog:false,
    valuation:null,
    addAttribute:'',
    itemkey:0,
    tableList:[],
    dialogVisible:false,
    publishFailed:[],
    showCaetgory:false,
    calcNum:0,
    productName:'',
    changePicObj:-1,
    active: 0,
    cateList:[],
    priceValue:'',
    stockValue:'',
    activeName:'ROOT',
    categoryList:[],
    secondCategory:[],
    imgList:[
      '',
      'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/6e01a45243154306959f5fae1c99b37b.jpg',
      'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/a704a09903c847f9a491b6604dda376b.jpg',
      'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/9d2c717cef94441e90f856de046c6a72.jpg',
      
    ],
    thiryCategory:[],
    fourCategory:[],
    fiveCategory:[],
    categoryIdList:[],
    firstCategorylist:[{
        checked:true,
        checked02:false,
        name:this.$t('other.a1293')
    }],
    firstCategory:'',
    attributes:[],
    shopOptions:[],
    sitelist:[{
        label:this.$t('other.a1294'),
        value:'ROOT'
    },
    // {
    //         label:this.$t('other.a1295'),
    //         value:'DXS'
    //     }
        ],
    counstSite:[],
    radio:''  ,
    radio2:null,
    dialogVisible:false,
    pskuItem:null,
    getDataList:{
        component:true,
        cusCode:'',
        offset:15,
        page:0,
        sellerId:JSON.parse(localStorage.getItem('userInfo')).userId,
        storeId:null,
        userId:JSON.parse(localStorage.getItem('userInfo')).userId
    },
    wareOptions:[],
    storeValue:null,
    currentPage4:1,
    tableCount:0,
    searchCuscode:null,
    searchText:'',
    tierVariations:[],
    fabuProduct:false,
    addOthers:false,
    countryOption:[],
    updatPic:false,
    token:{
        token:JSON.parse(localStorage.getItem('userInfo')).token
    },
    formulaList:[],
    conversiongTips:{
        "variation name length should less then :20":this.$t('other.a2879'),
        'item upload controller title_len no pass : lowLimit : 20 - UpperLimit : 10':this.$t('other.a2880'),
    },
    userInfoProduct:[],

}
},

  components: {
     draggable
  },

  inject:['reload'],

computed: {//这一部分直接拿过来用的
    ...mapState({
        ModelData: state => state.common.ModelData
       
    }),

    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },

    list(){
        let arr=[]
        for(let i=0;i<9;i++){
            arr.push('')
        }

        return arr 
    }
  },

  watch:{
      valuation(){
          if(this.valuation){
              console.log('okngl',this.valuation)
              let obj=JSON.parse(JSON.stringify(this.valuation))
              obj.profitRate=Number(obj.profit)/100+1
                setTimeout(() => {
                    this.ruleForm.variations.forEach(p => {
                        p.price=(p.supplyPrice+Number(obj.outboundfee))/Number(obj.rate)*obj.profitRate
                        p.price=p.price/(1-obj.discount/100)
                        p.price=p.price.toFixed(2)
                    })

                    console.log('okgjkgmb',this.ruleForm)
                },1000)

          }else{
              if(!this.route.query.childrenProductId){
                  this.ruleForm.variations.forEach(p => {
                            p.price=null
                    })
              }
          }
      },
      calcNum(){
            this.percentage=Math.round(this.calcNum/this.imageLength*100)
        },
      categories(){
          this.ruleForm.categories=this.categories
      },
     dialogVisible(){
         if(!this.dialogVisible){
             this.pskuItem=null
             this.radio2=null
         }
     },

     waterDialog(){
        if(!this.waterDialog){
        this.imgUrl=null
        this.imageLength=0
        this.percentage=0
        }
    },
     searchCuscode(){
         if(!this.searchCuscode){
             this.getDataList.cusCode=null
             this.getStoreItem()
         }
     },

     replaceImg(){
         if(!this.replaceImg){
             this.showPersoun=false
             this.shopeeUrl=null
             
         }
     },

     targetShopId(){
         this.logisticeByshop=[]
         let params={
             categoryId:this.categoryIdList[this.categoryIdList.length-1],
             shopId:this.targetShopId
         }
         console.log('pargdfgfgams',params)
         if(params.categoryId){

             this.getLoagistics(params)
         }
        //  this.targetShopId.forEach(k => {
        //      this.getLoagistics(k)
        //  })
      
     },

     updatPic(){
        if(!this.updatPic){
            this.imageUrl=''
        }
    },
     checkedAlllogisctic(){
         if(this.checkedAlllogisctic){
             this.logisticeByshop.forEach(k => {
                 k.enabled=true
             })
         }else{
             this.logisticeByshop.forEach(k => {
                 k.enabled=false
             })
         }
     },

     searchText(){
            console.log('8888',this.searchText,this.targetIndex)
            if(this.searchText){
                this.attributes[this.targetIndex].unit=null
                this.attributes[this.targetIndex].options=this.attributes[this.targetIndex].optionsCopy
                this.attributes[this.targetIndex].options=this.attributes[this.targetIndex].options.filter(item => {
                    if(item.includes(this.searchText)){
                        return item
                    }
                })

            }else{
                p.options=p.optionsCopy
            }
            console.log('attributes',this.attributes)
        }
  },



created(){
 this.getUserCache()
 this.init()
 this.getUserSuplist();
 
 let arr1 = [];
    let arr2 = [];
    JSON.parse(localStorage.getItem("userInfo")).stores.forEach((p) => {
      if (p.isUsed) {
        if (p.storeType == 1) {
          arr1.push({
            label: p.storeName,
            value: p.storeId,
          });
        } else {
          arr2.push({
            label: p.storeName,
            value: p.storeId,
          });
        }
      }
    });
    this.warehouseOption = [...arr1, ...arr2];
},

directives:{
    clickOutSide:{
        bind:function(el, binding , vnode){
            function documentHandler(e){
                if(el.contains(e.target)){
                return false
                }

                if(binding.expression){
                    binding.value(e)
                }
            }
            el._vueClickOutside_ =documentHandler
            document.addEventListener('click',documentHandler)
        },

        unbind:function (el,binding) {
            document.removeEventListener('click',el._vueClickOutside_)
        }

    },
    el_selectLoadmore:{
        bind(el,binding){
            let self=this
            const SELECTWRAP_DOM =el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
           
            SELECTWRAP_DOM.addEventListener('scroll', function () {
                const condition = this.scrollHeight - this.scrollTop-20 <= this.clientHeight
                if (condition) binding.value()
            })
        }
    }
},
methods:{
    
    publishAgine(item){
        console.log('item',item)
        console.log('ruleform',this.ruleForm)
        this.ruleForm=item
        this.activeName=item.country
        

        this.getShopOptions()
        this.formulaList=[]
        this.getCache()
        console.log('777',this.ruleForm)
        setTimeout(() => {
            this.targetShopId=this.ruleForm.productShops[0].shopId
        },200) 


        api
        .getCategoryByCountry({
            country:this.activeName,
        })
        .then(res => {
            if(res.code === 200){
                console.log('国家获取类目',res.data)
                let originListCopy=JSON.parse(JSON.stringify(res.data)) 
                this.categoryList=res.data
                if(this.ruleForm.categoryId){
                    console.log(this.ruleForm.categoryId)
                   
                    let id=this.ruleForm.categoryId
                    let list=[]
                    this.categoryIdList=[]

                    originListCopy.forEach(p => {
                        p.childrens.forEach(k => {
                            if(k.categoryId === id){
                                list.push(p.categoryName)
                                list.push(k.categoryName)
                                this.categoryIdList.push(p.categoryId)
                                this.categoryIdList.push(k.categoryId)
                            }else{
                                if(k.childrens !== null){
                                     k.childrens.forEach(i => {
                                    if(i.categoryId === id){
                                         list.push(p.categoryName)
                                         list.push(k.categoryName)
                                         list.push(i.categoryName)
                                         this.categoryIdList.push(p.categoryId)
                                         this.categoryIdList.push(k.categoryId)
                                         this.categoryIdList.push(i.categoryId)
                                    }
                                })
                                }
                               
                            }
                        })
                    })
                    console.log('list',list)
                    this.categories=list.join(' / ')
                    console.log(this.categoryIdList)
                    console.log(this.ruleForm)   
                }
              
               
            }else{
                this.$message.warning(res.msg)
            }
        })
       

       

    },

    getCache(){
        let ttp=null
        utils.getInfoByCache({
            cacheKey:'formula'+this.activeName,
            userId:this.userId,
        }).then(res => {
            if(res !== null){
                this.formulaList=res
                this.formulaList.forEach(p => {
                    p.discount=p.discount ? p.discount : 0
                })
                console.log('计算公式',this.formulaList)
                if(this.formulaList && this.formulaList.length){
                    this.valuation=this.formulaList.find(item => item.default)
                }else{
                    this.valuation=null
                }
                
            }else{
                this.formulaList=[]
            }
           
        })
    },

    

    setDefault(item,index){
        if(item.default){
            item.default=false
        }else{

            this.formulaList.forEach(p => {
                p.default=false
            })
    
            item.default=true
        }
        this.itemkey++
        utils.updateInfoByCache({
            cacheKey:'formula'+this.activeName,
            userId:this.userId,
            cacheData:JSON.stringify(this.formulaList)
        }).then(res => {
           
            console.log('ttp',res)
            this.getCache()
        })

        console.log(this.formulaList)
    },

    updateRule(item,index,num){
        console.log(item,index)
        this.variation=null
        if(num == 0){
            this.formulaList.splice(index,1)
             
        }
        item.checked=false
        utils.updateInfoByCache({
            cacheKey:'formula'+this.activeName,
            userId:this.userId,
            cacheData:JSON.stringify(this.formulaList)
        }).then(res => {
            
           this.getCache()
           console.log('ttp',this.valuation)
        })
    },

    addNewFormula(){
        let num=this.formulaList.length+1
        this.formulaList.unshift({
            id:num,
            country:this.activeName,
            dropshippingFee:0,
            outboundfee:0,
            rate:0,
            profit:0,
            discount:0,
            checked:true
        })
    },

    imgConfirm(){
        console.log(this.changePicObj)
        console.log(this.imageUrl)
        console.log(this.ruleForm)
        this.ruleForm.tiers[0].images[this.changePicObj]=this.imageUrl
        this.itemKey++
        this.updatPic=false
        this.changeAttrPic=false
        
    },

    deleAttrImg(index){
        console.log(this.ruleForm.tiers[0].images)
        this.ruleForm.tiers[0].images[index]=null
    },
    getCurrencyCopy(code){
        return utils.getCurrency(code)
    },
    getCountryName(code){
        return utils.getCountryName(code)
    },
    getUserSuplist() {
      api
        .getsuplist({
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
            this.supplierData = res.productSuppliers;
          } else {
            this.$message.warning(res.msg);
          }
        });
    }, //获取用户的供应商

    handlePic(item,index){
        this.imgUrl=item.watermarkUrl
    },

    handleAvatarSuccess(res, file) {
    console.log(res,file)
    this.imageUrl = res.data
    

    console.log('imageUrl',res.data)
    },

    beforeAvatarUpload(file) {
        console.log('files',file)
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            this.$message.error(this.$t("other.a333"));
        }
        return  isLt2M;
    },

    deleteWaterImg(item,index){
        this.$confirm(this.$t('other.a564'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            api
            .deleteWaterImg({
                userId:this.userId,
                watermarkIds:[item.id]
            })
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.$message.success(this.$t('other.a565'))
            this.imgList.splice(index,1)
            }else{
            this.$message.warning(res.msg)
            }
            })
        })
    },
    addWaterImg(num){
        if(num == 1){
            this.imageLength=1
            this.getWaterPiuture(this.ruleForm.images[0].image,this.imgUrl,0)
        }else{
            this.imageLength=this.ruleForm.images.length
            this.ruleForm.images.forEach((p,index) => {
                if(p.image){
                    this.getWaterPiuture(p.image,this.imgUrl,index)
                }
            })
        }
       
        


    },

    getWaterPiuture(originImg,waterImg,index){
        return new Promise((resolve) => {
            let that=this
            var canvas = document.createElement("canvas");
            canvas.width=800
            canvas.height=800
            let ctx=canvas.getContext('2d')
            let homeImg=originImg
            let picImg=new Image()
            picImg.setAttribute('crossOrigin', 'anonymous');
            picImg.src=homeImg
            
            picImg.onload = function() {
                ctx.drawImage(picImg,0,0,800,800);
                let base64=canvas.toDataURL('image/png')
                
                let image=new Image()
                image.src=waterImg
                image.setAttribute('crossOrigin', 'anonymous');
                image.onload = function() {
                    ctx.drawImage(image,0,0,800,800);
                    let base64=canvas.toDataURL('image/png')
                    
                    var blob = that.dataURItoBlob(base64); // 上一步中的函数
                    var canvasOne = document.createElement('canvas');
                    var dataURL = canvasOne.toDataURL('image/jpeg', 0.5);
                    var fd = new FormData(document.forms[0]);
                    fd.append("file", blob, 'image.png');
                    fd.append('shopId',JSON.parse(localStorage.getItem('userInfo')).shopeeShops[0].shopId)
                    fd.append('isUploadToShopee',true)
                    api
                    .uploadImg(fd)
                    .then(res => {
                        if(res.code == 200) {
                            resolve(res.data) 
                            
                            that.ruleForm.images[index].image=res.data.image_info_list[0].image_info.image_url_list[0].image_url
                            that.ruleForm.images[index].imageId=res.data.image_info_list[0].image_info.image_id
                            that.calcNum+=1
                           
                            
                        }else{
                            that.$message.warning(res.msg)
                        }
                    })
                }  
            }


        })

    },


    okngknv(){
        this.toDataURLCopy('https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/7f315ae08ad54cb8b71eea0838a98696.jpg',(res) => {
            console.log('res',res)
        })

        
        
       
        // // originJsonp中的参数说明可以到前言中的github中查看
        // originJsonp('https://cf.shopee.com.my/file/68c702a23083577576ba569b1eb45dc3',  (err, data) => {
        //     if(!err){
        //         console.log('data',data)
        //     }else{
        //         console.log(err)
        //     }
            
        
        // })

    },

    



    toDataURLCopy(url, callback) {
        console.log(123)
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },




    dataURItoBlob(base64Data) {
        var byteString;
        if (base64Data.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(base64Data.split(',')[1]);
        else
        byteString = unescape(base64Data.split(',')[1]);
        var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], {type:mimeString});
    },

    draftBox(){
        this.publishFailedDia=true

        console.log('publishFailed',this.publishFailed)
    },

    //检查函数
    checkData(){
        let flag=false
        if(this.ruleForm.country === 'ROOT'){
            this.$message.warning(this.$t('other.a1297'))
            return flag=true
        }
        if(this.activeName !== 'DXS'){
            if(this.ruleForm.productShops.length == 0){
                this.$refs.shopAndCategory.scrollIntoView()
                this.$message.warning(this.$t('other.a1298'))
                return flag=true
            }
        }
        if(!this.categories && this.activeName !== 'DXS'){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1285'))
            return flag=true
        }

        if(!this.ruleForm.attributes.length && this.activeName !== 'DXS'){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1299'))
            return flag=true
        }

        let list=[]
        this.ruleForm.variations.forEach(p => {
            if(!p.price){
                list.push(p)
            }
        })
        if(list.length) {
            this.$refs.variations.scrollIntoView()
            this.$message.warning(this.$t('other.a1300'))
            return flag=true
        }

        if(!this.ruleForm.weight  && this.activeName !== 'DXS'){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1301'))
            return flag=true
        }
        if(!this.ruleForm.packageHeight || !this.ruleForm.packageLength  || !this.ruleForm.packageWidth){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1301'))
            return flag=true
        }
        let list2=[]
        this.logisticeByshop.forEach(p => {
            if(p.enabled){
                list2.push(p)
            }
        })

        if(!list2.length && this.activeName !== 'DXS'){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1302'))
            return flag=true
        }

        
    },

    deleItem(index){
        let ttp=JSON.parse(JSON.stringify(this.userInfoProduct))
        ttp.splice(index,1)
        console.log('ttp',ttp)
        utils.updateInfoByCache({
            cacheKey:'productModel',
            userId:this.userId,
            cacheData:JSON.stringify(ttp)
        }).then(res => {
            if(res.code == 200){
                this.$message.success(this.$t('other.a1439'))
                this.getUserCache()
            }else{
                this.$message.warning(res.msg)
            }

        })
    },

    saveProdcutModel(){
        console.log('ruleForm',this.ruleForm)
        this.ruleForm.time=utils.getNowTime()
        this.userInfoProduct.unshift(this.ruleForm)
        let ttp=JSON.parse(JSON.stringify(this.userInfoProduct))
        console.log('ttp',ttp)
        utils.updateInfoByCache({
            cacheKey:'productModel',
            userId:this.userId,
            cacheData:JSON.stringify(ttp)
        }).then(res => {
            if(res.code == 200){
                this.$message.success(this.$t('other.a1440'))
                this.getUserCache()
            }else{
                this.$message.warning(res.msg)
            }

        })
    },

    updataLink(){
        console.log(this.ruleForm)
        this.showLoading()
        api
        .updataItemOnline({
            itemId:this.ruleForm.items[0].itemId,
            shopId:this.ruleForm.items[0].shopId,
            userProduct:this.ruleForm
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.$message.success(this.$t('other.a1231'))
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    checkImgData(){
        let falg=this.ruleForm.tiers[0].images.filter(k => {
            if(k !== null  && k.indexOf('shopsbu') > -1){
                return k
            }
        })
        console.log('falg',falg)
        let images=this.ruleForm.tiers[0].images
        let list=[]
        if(falg.length > 0){
            images.forEach((p,index) => {
                if(p !==null && p.indexOf('shopsbu') > -1 && p !==''){
                    list.push(p)
                    api
                    .uploadShopeeByImgUrl({
                        shopId:JSON.parse(localStorage.getItem('userInfo')).shopIds[1],
                        url:p
                    })
                    .then(res => {
                        console.log('res88552',res)
                        if(res.code === 200 ){
                        list.splice(0,1)    
                        images[index]=res.data.image_info_list[0].image_info.image_url_list[0].image_url
                        if(!list.length){
                            this.immediatelyPublish()
                               
                        }
                        
                        }else{
                        this.$message.warning(res.msg)
                        }
                    })
                   
                }
            })
            
        }else{
            this.immediatelyPublish()

        }
        
        
        
    },


    // 分销产品立即发布到线上
    immediatelyPublish(){
        let ttp = this.checkData()
        console.log('ttp',ttp)
        if(ttp){
            return
        }else{

        if(this.logisticeByshop.length){//如果用户选择了商店，自动帮助用户填充物流的默认信息
            this.ruleForm.logistics=this.logisticeByshop.filter(k => {
                k.logisticId=k.logistics_channel_id
                if(k.enabled){
                    return k
                }
            })
        }

        this.ruleForm.modelId=this.$route.query.id
        let imageList=[]
        this.ruleForm.images.forEach((p,index) => {
            p.positions=index
            if(p.image){
                imageList.push(p)
            }
        })

        this.ruleForm.images=imageList


        if(this.ruleForm.productId){
            api
            .updataProduct(this.ruleForm)
            .then(res => {
            if(res.code === 200 ){
                api
                .publishProducts({
                    productId:this.ruleForm.productId,
                    userId:this.userId
                })
                .then(res => {
                    console.log('重新发布',res)
                    if(res.code === 200){
                                res.data.forEach(p => {
                                if(p.msg.indexOf('上架成功') > -1) {
                                    this.$message.success(p.msg)
                                }else{
                                    let testDesc=null
                                    if(p.msg== 'item upload controller description_len no pass : lowLimit : 2 - UpperLimit : 3000  '){
                                        testDesc=this.$t('other.a1441')
                                    }else if(p.msg.indexOf("wrong sign") > -1){
                                        testDesc=this.$t('other.a1442')
                                    }else{
                                        testDesc=p.msg
                                    }

                                    this.$confirm(testDesc, this.$t("other.a142"), {
                                    confirmButtonText: this.$t("other.a884"),
                                    cancelButtonText: this.$t('other.a146'),
                                    type: 'warning'
                                    }).then(() => {})
                                }
                                
                            })
                    }
                })
            
            }else{
            this.$message.warning(res.msg)
            }
            })
            return 
        }    


        showLoading()
        api
        .updataProduct(this.ruleForm)
        .then(res => {
            if(res.code === 200){
                console.log('新增模版',res.data)
                let newModel=res.data
                this.ruleForm.productId=res.data.productId

                if(this.activeName == 'DXS'){
                    api
                    .publishProductToDXS({
                        productId:res.data.productId,
                        userId:this.userId,
                        online:true
                        
                    })
                    .then(res => {
                        if(res.code === 200){
                        this.$message.success(this.$t('other.a1303'))
                      
                        }else{
                            this.$message.warning(res.msg)
                        }
                    })

                    return
                }
                 api
                .publishProducts({
                    productId:res.data.productId,
                    userId:this.userId
                })
                .then(res => {
                    if(res.code === 200){
                            res.data.forEach(p => {
                            if(p.msg.indexOf('上架成功') > -1) {
                                this.$message.success(p.msg)
                            
                            }else{
                                let testDesc=null
                                if(p.msg== 'item upload controller description_len no pass : lowLimit : 2 - UpperLimit : 3000  '){
                                    testDesc=this.$t('other.a1441')
                                }else if(p.msg.indexOf("wrong sign") > -1){
                                    testDesc=this.$t('other.a1443')
                                }else{
                                    testDesc=p.msg
                                }
                                
                                this.$confirm(testDesc, this.$t("other.a142"), {
                                confirmButtonText: this.$t("other.a884"),
                                cancelButtonText: this.$t('other.a146'),
                                type: 'warning'
                                }).then(() => {})
                            }
                            
                        })
                    }else{
                        this.$message.warning(res.msg)
                    }
                })    
            }else{
                this.$message.warning(res.msg)
                
            }
        })

         }
    },

    syncLogistics(){
        this.logisticeByshop=[]
        api
        .getShopLogisticsAndAttribute({shopId:this.targetShopId,categoryId:this.categoryIdList[this.categoryIdList.length-1]})
        .then(res => {
            if(res.code === 200) {
                console.log('物流和类目',res.data)
                let logistics=res.data.logistics
                let attributes=res.data.attributes
                let list=[]
                logistics.forEach(k => {
                    k.checked=false 
                    if(k.enabled){
                        list.push(k)
                    }
                    
                })


                this.logisticeByshop.push(...list)
                // let obj1 = {};
                // let res1 = [];
                // this.logisticeByshop.forEach(k => {
                //     if(!obj1[k.logisticId]){
                //         res1.push(k)
                //         obj1[k.logisticId]=1
                //     }
                // })

                // this.logisticeByshop=res1
                console.log('logisticeByshop',this.logisticeByshop)
                this.$message.success(this.$t('other.a1304'))
                
            }
        })
        
    },

    //获取线上的商品主图
    getOnlineProduct(country,itemId,shopId){
        this.showPersoun=true
        let  list=utils.getParamsInProductUrl(this.shopeeUrl)
        let host=this.shopeeUrl.substring(0, this.shopeeUrl.indexOf('/', 8) + 1)+'api/v4/item/get'+'?' 
        let matchId="itemid=" +list[1]+ '&' + "shopid=" + list[0]
        let if_match_="55b03-" + md5.hex("55b03" + md5.hex(matchId) + "55b03")
        let url=host+matchId
        console.log('list',list)
        console.log('host',host)
            
        api
        .scrapedProdcutItem({
            ifMatchIn:if_match_,
            origin:host,
            url:host+matchId
        })
        .then(res => {
            console.log(res.data)

            let list=[]
            res.data.images.forEach((p,index) => {
                list.push({
                    image:utils.getImageUrl(host,p),
                    itemId:null,
                    positions:index,
                    productId:null
                })
            })

            setTimeout(() => {
                this.percentage=50
            },1000)

            setTimeout(() => {
                this.percentage=100
                if(list.length > 0){
                    this.ruleForm.images=list
                }
                
            },2000)

        })
    
    },

    getLoagistics(params){

            
            
            api
            .getShopLogisticsAndAttribute(params)
            .then(res => {
                if(res.code === 200) {
                    this.logisticeByshop=[]
                    console.log('物流和类目',res.data)
                    let logistics=res.data.logistics
                    let attributes=res.data.attributes
    
                   
                    attributes.forEach(p => {
                        p.userValue=''
                    })
                    console.log('rules',this.rules)
                    attributes.forEach(p => {
                        p.optionsCopy=p.options
                    })
                    attributes.sort((a,b) => {
                        return a.attribute_name.charCodeAt(0)-b.attribute_name.charCodeAt(0)
                    })
                    this.attributes=attributes
                    console.log('attributes',this.attributes)
                    let list=[]
                    logistics.forEach(k => {
                        k.checked=false 
                        if(k.enabled){
                            list.push(k)
                        }
                    })
    
                    this.logisticeByshop.push(...list)
                    // let obj1 = {};
                    // let res1 = [];
                    // this.logisticeByshop.forEach(k => {
                    //     if(!obj1[k.logisticId]){
                    //         res1.push(k)
                    //         obj1[k.logisticId]=true
                    //     }
                    // })
    
                    // this.logisticeByshop=res1
                    console.log('logisticeByshop',this.logisticeByshop)
                   
               
                   
                }else{
                    this.$message.warning(res.msg)
                }
            })
        

        
    },

    loadMore(){
        return () => this.rangeNumber += 5
    },
    getDataType(price){
        let ttp=null
        if(price == '' || price == null || price == undefined){
            ttp=''
        }else{
            ttp=Number(price)
        }

        return ttp
    },

    changeValue(){
        console.log(this.ruleForm)
    },

    manageUser(){
       
        this.showCaetgory=true
    },
    handleClose(){
        this.showCaetgory=false
    },


    cateGory(item,index){
        console.log(item)
        if(index == 1){
           this.secondCategory=item.childrens
           this.thiryCategory=[]
           this.cateList[index-1]=item.categoryName
           this.categoryIdList[index-1]=item.categoryId
           this.cateList.splice(index,1)
           this.categoryIdList.splice(index,1)
           
        }else if(index == 2){
            this.thiryCategory=item.childrens
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.cateList.splice(index,1)
            this.categoryIdList.splice(index,1)
        }else if(index == 3){
            this.fourCategory=item.childrens
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.categoryIdList.splice(index,1)
        }else if(index == 4){
            this.fiveCategory=item.childrens
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.categoryIdList.splice(index,1)
        }else if(index == 5){
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.categoryIdList.splice(index,1)
        }


        this.categories=this.cateList.join(' / ')
        if(item.childrens == null){
            this.showCaetgory=false
            this.thiryCategory=[]
            this.fourCategory=[]
            this.secondCategory=[]
            this.fiveCategory=[]
            // this.getAttributesData()
            this.ruleForm.categoryId=this.categoryIdList[this.categoryIdList.length-1]    

        }

        this.logisticeByshop=[]
         let params={
             categoryId:this.categoryIdList[this.categoryIdList.length-1],
             shopId:this.targetShopId
         }
         console.log('params',params)
         this.getLoagistics(params)

        console.log(this.ruleForm)
        console.log('categoryIdList',this.categoryIdList)
        console.log(this.cateList)
    },

    getAttributesData(){
        api
        .getAttributes({
            country:this.activeName,
            categoryId:this.categoryIdList[this.categoryIdList.length-1]

        })
        .then(res => {
            if(res.code == 200){
                console.log('品牌',res.data)
                res.data.forEach(p => {
                    p.userValue=''
                })
                console.log('rules',this.rules)
                res.data.forEach(p => {
                    p.optionsCopy=p.options
                })
                console.log(res.data)
                this.attributes=res.data
                console.log('attributes',this.attributes)
            }
        })
    },

    

    getShopId(){
        console.log(this.targetShopId)

        this.ruleForm.productShops=[{shopId:this.targetShopId}]
    },

    dataFilter(item,index){
        console.log(item,index)
    },

    getShop(){
        const country={
            'TH':this.$t('other.a1305'),
            'PH':this.$t('other.a1306'),
            'ID':this.$t('other.a1307'),
            'MY':this.$t('other.a1308'),
            'TW':this.$t('other.a1309'),
            'VN':this.$t('other.a1310'),
          
        }
        
        let arr=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
        let arr2=[]
        arr.forEach(p => {
            arr2.push(p.country)
       
        })

        arr2=[...new Set(arr2)]

        arr2.forEach(p => {
            this.sitelist.push({
                label:country[p],
                value:p
            })

        })

        console.log('5555',this.sitelist)
       
        
        
    },

    deleteItem(index){
        this.ruleForm.variations.splice(index,1)
        console.log(this.ruleForm)
    },

     

    delAttr(index,index02){
        console.log(index,index02)
        console.log(this.ruleForm)
        this.ruleForm.tiers[index].listItem.splice(index02,1)
        this.ruleForm.tiers[index].optionArray.splice(index02,1)
        this.ruleForm.tiers[index].images.splice(index02,1)
        this.ruleForm.tiers[index].imagesUrl=JSON.stringify(this.ruleForm.tiers[index].images)
        // this.$set(this.ruleForm.tiers,index,this.ruleForm.tiers[index])

        if(index == 0){//如果用户删除的第一级的属性
            let list=[]
            // this.ruleForm.variations.forEach((p,index) => {
            //     if(p.tierIndex[0] !== index02){
            //         list.push(p)
            //     }
            // })
            // this.ruleForm.variations=list


            
            this.ruleForm.variations.splice(index02,1)
            this.ruleForm.variations.forEach((p,index) => {
                p.tierIndex[0]=index
            })
            console.log(this.ruleForm)

        }

        if(index == 1) {
            let list=[]
            this.ruleForm.variations.forEach((p,index) => {
                if(p.tierIndex[1] !== index02){
                    list.push(p)
                }
            })
            this.ruleForm.variations=list
            console.log(this.ruleForm)
        
        }

       
        
      
    },
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while(index < array.length) {
          newArray.push(array.slice(index, index += subGroupLength));
      }
      return newArray;
  },

    addOtherspp(index){
        console.log(this.ruleForm)
      
        this.ruleForm.tiers[index].listItem.push({
            name:this.ruleForm.tiers[index].firstCategory,
            checked02:false
        })
        this.ruleForm.tiers[index].optionArray.push(
            this.ruleForm.tiers[index].firstCategory
        )
        // this.ruleForm.tiers[index].images.push(null)
        // this.ruleForm.tiers[index].imagesUrl=JSON.stringify(this.ruleForm.tiers[index].images)
        this.$set(this.ruleForm.tiers,index,this.ruleForm.tiers[index])  
        console.log(this.ruleForm.tiers,index)
        this.ruleForm.tiers[index].firstCategory=''

        if(index == 0){

            let list=[]
            if(this.ruleForm.tiers.length > 1) {
                this.ruleForm.tiers[1].optionArray.forEach((i,index) => {
                    this.ruleForm.variations.push({
                        cusCode:null,
                        tierIndex:[this.ruleForm.tiers[0].optionArray.length-1,index],
                        variationSku:this.ruleForm.tiers[0].optionArray[this.ruleForm.tiers[0].optionArray.length-1]+','+this.ruleForm.tiers[1].optionArray[index],
                        stock:'',
                        price:'',
                        cost: this.ruleForm.variations[0].cost,
                        costCopy: this.ruleForm.variations[0].costCopy,
                    })
                })

                 console.log('list',list)
            }else{
                 this.ruleForm.variations.push({
                        cusCode:null,
                        tierIndex:[this.ruleForm.tiers[0].optionArray.length-1],
                        variationSku:this.ruleForm.tiers[0].optionArray[this.ruleForm.tiers[0].optionArray.length-1]+ '_' +utils.randomString(6),
                        stock:'',
                        price:''
                    })
            }
        }

        if(index == 1){
            console.log(this.ruleForm)
            
            let list=[]
            
            this.ruleForm.tiers[0].optionArray.forEach((p,index) => {
                let obj={
                    usCode:null,
                    price:'',
                    stock:'',
                    tierIndex:[index,this.ruleForm.tiers[1].optionArray.length-1],
                    variationSku:this.ruleForm.tiers[0].optionArray[index]+','+this.ruleForm.tiers[1].optionArray[this.ruleForm.tiers[1].optionArray.length-1]
                }
                list.push(obj)
            })

            console.log('list',list)
            if(list.length){
                this.ruleForm.variations=[]
                list.forEach(p => {
                    this.ruleForm.variations.push(p)
                })
            }  
        }
    },
    
    delAttItem(index){
        this.$confirm(this.$t('other.a1311'),this.$t("other.a142"),{
            confirmButtonText:this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
        }).then(() => {
            this.ruleForm.tiers.splice(index,1)
        })
    },

    addAttibuteItem(){
        console.log(this.addAttribute)
        if(this.ruleForm.tiers.length == 2){
            this.$message.warning(this.$t('other.a1312'))
            return
        }else if(!this.addAttribute){
           
            return
        }
        this.ruleForm.tiers.push({
            name:this.addAttribute,
            listItem:[],
            optionArray:[],
            images:[],

        })

        this.addAttribute=''
    },

    publishProduct(){
        this.$confirm(this.$t('other.a1313'),this.$t("other.a142"),{
            confirmButtonText:this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
        }).then(() => {
            console.log(this.ruleForm)
            let obj=this.ruleForm.children.find(p => p.country === this.activeName)
            console.log(obj)
            api
            .publishProducts({
                productId:obj.productId
            })
            .then(res => {
                if(res.code === 200){
                    this.$message.success(this.$t('other.a1314'))
                }
            })
        })
    },

    //根据用户切换的国家站点获取发布失败的模版数据
    getFaledModelBySite(code){
        
        this.failedlist=this.publishFailed.filter(p => {
            if(p.country == code){
                return p
            }
        })

        console.log('list8888',this.failedlist)
    },

    updataRuleform(){
        let falg=this.$route.query.childrenProductId
        if(falg && falg !== undefined){
            let ttp=this.ruleForm.children.find(item => item.productId == falg)
            console.log('updatabbb',ttp)
            this.ruleForm=ttp
            this.ruleForm.tiers.forEach(k => {
                k.checked02=false
                k.listItem=k.optionArray.map(k => {
                    return {
                        name:k,
                        checked02:false
                    }
                })
            })
    
             this.ruleForm.variations.forEach(p => {
                p.cost=null
                p.costCopy=null 
                p.supplyPrice=p.price 
            })
            this.targetShopId=this.ruleForm.productShops[0].shopId
            this.activeName=this.ruleForm.country
            console.log('variations111',this.ruleForm.variations)
            this.getCategory()
            // this.ruleForm.productShops= [{shopId:this.targetShopId}]
        }else{
            
        }
    },

    //根据国家站点获取店铺
    getShopOptions(){
        this.shopOptions=[]
        let shoplist=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
        shoplist.forEach(p => {
            if(p.country === this.activeName){
                this.shopOptions.push({
                    label:p.shopName,
                    value:p.shopId
                })
            }
        })

        console.log('shopOptions',this.shopOptions)
    },
    getCategory(){
        this.ruleForm.country=this.activeName
        this.getShopOptions()
        this.formulaList=[]
        this.getCache()
        if(!this.$route.query.childrenProductId){//重新发布
            this.targetShopId=null
            this.ruleForm.variations.forEach(p  => {
                p.cost=p.costCopy +this.$t('other.a1445') + utils.getCountryName(this.activeName) +this.$t('other.a1446') + (utils.getCurrency(this.activeName))
            })
        }else{
            this.targetShopId=null
            setTimeout(() => {
                this.targetShopId=this.ruleForm.productShops[0].shopId
            },200)   
        }

        
        console.log('777',this.ruleForm)
          
        

        api
        .getCategoryByCountry({
            country:this.activeName,
        })
        .then(res => {
            if(res.code === 200){
                console.log('国家获取类目',res.data)
                let originListCopy=JSON.parse(JSON.stringify(res.data)) 
                this.categoryList=res.data
                if(this.ruleForm.categoryId){
                    console.log(this.ruleForm.categoryId)
                   
                    let id=this.ruleForm.categoryId
                    let list=[]
                    this.categoryIdList=[]

                    originListCopy.forEach(p => {
                        p.childrens.forEach(k => {
                            if(k.categoryId === id){
                                list.push(p.categoryName)
                                list.push(k.categoryName)
                                this.categoryIdList.push(p.categoryId)
                                this.categoryIdList.push(k.categoryId)
                            }else{
                                if(k.childrens !== null){
                                     k.childrens.forEach(i => {
                                    if(i.categoryId === id){
                                         list.push(p.categoryName)
                                         list.push(k.categoryName)
                                         list.push(i.categoryName)
                                         this.categoryIdList.push(p.categoryId)
                                         this.categoryIdList.push(k.categoryId)
                                         this.categoryIdList.push(i.categoryId)
                                    }
                                })
                                }
                               
                            }
                        })
                    })
                    console.log('list',list)
                    this.categories=list.join(' / ')
                    console.log(this.categoryIdList)
                    console.log(this.ruleForm)   
                }
              
               
            }else{
                this.$message.warning(res.msg)
            }
        })
    },

    createModel(){
        api
        .createProductModel({
            modelName:this.productName,
            userId:this.userId
        })
        .then(res => {
            if(res.code === 200){
                this.$message.success(this.$t('other.a1315'))
                console.log('创建的模版',res.data)

                this.options.push({
                    label:res.data.modelName,
                    value:res.data.modelId
                })
            }
        })
    },
    next() {
        if (this.active++ > 2) this.active = 0;
      },


    //信息填写的提示
    showTip(name,flag,text){
        let textone=text
        let flagone=flag
        console.log(flagone,flag)
        
        
        if(name == '' || name){
            this.$message.warning(textone)
            return
        }
    }, 
    addProducts(){
        // if(this.ruleForm.variations.length > 0){
                
        //         this.productDTO.itemSkuType = 2
        //     }else{
               
        //         this.productDTO.itemSkuType = 1
        //     }
        this.productDTO.productDescription = this.ruleForm.description;
        this.productDTO.productId = this.ruleForm.productId.toString();
        this.productDTO.productName = this.ruleForm.name;
        this.productDTO.productUrl = this.ruleForm.sourceUrl;

        this.productDTO.productSku = this.ruleForm.itemSku;
        this.ruleForm.images.forEach((p)=>{
            this.productDTO.productPhotoList.push(p.image)
        })
        this.productDTO.productLogistic.length = this.ruleForm.packageLength;
        this.productDTO.productLogistic.wide = this.ruleForm.packageWidth;
        this.productDTO.productLogistic.height = this.ruleForm.packageHeight;
        this.productDTO.productLogistic.weight = this.ruleForm.weight;
        this.productDTO.productLogistic.productId = this.ruleForm.productId.toString();
        // this.productDTO.productSkuList = this.ruleForm.variations;
        // this.productDTO.productAttributes = this.ruleForm.attributes;
        let arrnew = this.ruleForm.attributes.map((item, index) => {
        return Object.assign(
          {},
          {
            attributeId: item.attributeId.toString(),
            attributeName: item.attributeName,
            attributeType: 1,
            attributeValue: item.attributeValue,
            createdTime:"2021-09-13T06:23:16.912Z",
            productId : item.productId.toString(),
            updateTime : "2021-09-13T06:23:16.912Z"
          }
        );
      });
      if(this.radio == '2'){
           this.productDTO.itemSkuType = 2
          let arrnew2 = this.ruleForm.variations.map((item, index) => {
        return Object.assign(
          {},
          {
            skuName: item.variationSku,
            estimatedPurchasePrice: parseInt(item.price),
            inventory: parseInt(item.stock),
            productId: "",
            createdTime:"2021-09-13T06:23:16.912Z",
            skuId : "",
            updateTime : "2021-09-13T06:23:16.912Z"
          }
        );
      });
      this.productDTO.productSkuList = arrnew2;
      }else if (this.radio == '1'){
          this.productDTO.itemSkuType = 1
          this.ruleForm.variations[0].name = this.ruleForm.itemSku;
          this.ruleForm.variations[0].variationSku = this.ruleForm.itemSku;
          this.ruleForm.variations[0].price = this.ruleForm.price;
            this.ruleForm.variations[0].stock = this.ruleForm.stock;
            let arrnew2 = this.ruleForm.variations.map((item, index) => {
        return Object.assign(
          {},
          {
            skuName: item.variationSku,
            estimatedPurchasePrice: parseInt(item.price),
            inventory: parseInt(item.stock),
            productId: "",
            createdTime:"2021-09-13T06:23:16.912Z",
            skuId : "",
            updateTime : "2021-09-13T06:23:16.912Z"
          }
        );
      });
      console.log(arrnew2);
      this.productDTO.productSkuList = arrnew2;
      }
      
      this.productDTO.productAttributes = arrnew;
        this.productDTO.productAttributes.forEach((p)=>{
            p.attributeValues =[
                {
                attributeId:p.attributeId.toString(),
                attributeName:p.attributeName,
                attributeValue:p.attributeValue,
                attributeValueId:(p.productId+p.attributeId).toString(),
                createdTime:"2021-09-13T06:23:16.912Z",
                productId:p.productId.toString(),
                updatedTime:"2021-09-13T06:23:16.912Z"
            }
            ]
        })
        this.productDTO.productSkuList.forEach((k)=>{
            k.attributeList = [];
        })
        api
        .createproducts(this.productDTO)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
              this.$message.success(this.$t('other.a1227'));
            //   this.getUserHouse();
          }else{
            this.$message.warning(res.msg);
          }
         
        });
        console.log(this.ruleForm);
        console.log(this.productDTO);
    },//添加到产品库

    publishAndsave(){//保存并{{$t('other.a1388')}}
        console.log(this.sitelist)
        if(this.activeName == 'ROOT'){
            this.$message.warning(this.$t('other.a1316'))
            return
        }

    
        if(this.ruleForm.productShops.length == 0){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1298'))
            return
        }

        if(!this.categories){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1285'))
            return
        }

        if(!this.ruleForm.attributes.length ){
            this.$refs.shopAndCategory.scrollIntoView()
            this.$message.warning(this.$t('other.a1299'))
            return
        }

        let list=[]
        this.ruleForm.variations.forEach(p => {
            if(!p.price ){
                list.push(p)
            }
        })
        if(list.length) {
            this.$refs.variations.scrollIntoView()
            this.$message.warning(this.$t('other.a1317'))
            return
        }

        if(!this.ruleForm.weight ){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1301'))
            return
        }

        if(!this.ruleForm.packageHeight || !this.ruleForm.packageLength  || !this.ruleForm.packageWidth){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1301'))
            return
        }
        let list2=[]
        console.log('logisticeByshop',this.logisticeByshop)
        this.logisticeByshop.forEach(p => {
            if(p.enabled){
                list2.push({

                })
            }
        })
        if(!list2.length){
            this.$refs.logistic.scrollIntoView()
            this.$message.warning(this.$t('other.a1302'))
            return
        }

       
        if(this.logisticeByshop.length){//如果用户选择了商店，自动帮助用户填充物流的默认信息
            this.ruleForm.logistics=[]
            this.logisticeByshop.forEach(k => {
                if(k.enabled){
                    this.ruleForm.logistics.push({
                        enabled:k.enabled,
                        logisticId:k.logistics_channel_id,
                    })
                }
            })
        }
        this.ruleForm.modelId=this.$route.query.id
        let imageList=[]
        this.ruleForm.images.forEach((p,index) => {
            p.positions=index
            if(p.image){
                imageList.push(p)
            }
        })

        this.ruleForm.images=imageList

        this.ruleForm.modelId=this.$route.query.idModel
        this.ruleForm.productId=null

        console.log(1417,this.ruleForm)

        api
        .updataProduct(this.ruleForm)
        .then(res => {
            if(res.code === 200){
                console.log('新增模版',res.data)
                 api
                .publishProducts({
                    productId:res.data.productId,
                    userId:this.userId
                })
                .then(res => {
                    if(res.code === 200){
                            res.data.forEach(p => {
                            this.$message.success(p.msg)
                            if(p.msg.indexOf('上架成功') > -1) {
                              
                              setTimeout(() => {
                                   location.replace('/templateManagement')
                              },500)
                            }else{
                                
                            }
                            
                        })
                    }else{
                        this.$message.warning(res.msg)
                    }
                })    
            }else{
                this.$message.warning(res.msg)
                
            }
        })

    },

    saveItem(){
        delete this.ruleForm.radio  
        let imageList=[]
        this.ruleForm.images.forEach((p,index) => {
            p.positions=index
            if(p.image){
                imageList.push(p)
            }
        })

        this.ruleForm.images=imageList

        if(this.$route.query.addOthers){//母模版下新增商品
           this.ruleForm.modelId=this.ruleForm.productId
           this.ruleForm.productId=null
           if(this.activeName === 'DXS'){
               this.ruleForm.status='DXS'
           }else{
               this.ruleForm.country=this.activeName
           }
        }

        if(this.$route.query.productId){//保存商品到用户选择的站点
            this.ruleForm.modelId=Number(this.$route.query.productId)
            if(this.activeName === 'DXS'){
               this.ruleForm.status='DXS'
           }
        }

        if(this.$route.query.id){//保存商品到用户选择的站点
            this.ruleForm.modelId=Number(this.$route.query.id)
        }

        if(this.logisticeByshop.length){//如果用户选择了商店，自动帮助用户填充物流的默认信息
            this.ruleForm.logistics=[]
            this.logisticeByshop.forEach(k => {
                if(k.enabled){
                    this.ruleForm.logistics.push({
                        enabled:k.enabled,
                        logisticId:k.logistics_channel_id,
                    })
                }
            })
        }

        
       console.log(this.ruleForm)
       

        api
        .updataProduct(this.ruleForm)
        .then(res => {
            if(res.code === 200){
                console.log('新增模版',res.data)
                this.$message.success(this.$t('other.a1411'))
                localStorage.removeItem('modelId')
                setTimeout(() => {
                    this.$router.push('/templateManagement')
                },500)
                
            }else{
                this.$message.warning(res.msg)
            }
        })
    },
    cancel(){
       
                    this.$router.push('/templateManagement')
              
    },

    pushAttribute(){
        console.log(this.attributes,this.rangeNumber)
        let list=this.attributes.map(p => {

            let ttp=p.unit ? p.unit : ''
            return {
                attributeId:p.attribute_id,
                attributeName:p.attribute_name,
                attributeValue:p.userValue + ttp,
                isMandatory:p.is_mandatory

            }
        })
        

        this.ruleForm.attributes=list
        console.log(this.ruleForm)
    },

    back(){
        this.$router.push({
            path:this.$route.query.from
        })
    },

    showShopName(id){
        return utils.showShopNameByshopId(id)
    },

  
    


    setPrice(num){
       console.log(this.ruleForm)
       
       if(
           num == 1
           && this.priceValue !== ''
           && this.priceValue !== null
           && this.priceValue !== undefined
           ){
              this.ruleForm.variations.forEach(p => {
                    p.price=this.priceValue
                })
       }else if(num == 2 
       && this.stockValue !== ''
       && this.stockValue !== null
       && this.stockValue !== undefined
       
       ){
           this.ruleForm.variations.forEach(p => {
                    p.stock=this.stockValue
                })
       }
    
       
    },

    addItmes(num,index){
        if(num ==0) {
            this.ruleForm.variations.push({
                name:'',
                price:'',
                stock:'',
                variationSku:'',
            })
        }else{
            this.ruleForm.variations.splice(index,1)
        }
    },

    findItem(item,index,e){
        console.log(index)
        this.targetIndex=index
        var str = this.$refs.searchSelect[index].$data.selectedLabel

        console.log(str)
        this.searchText=str
    },
    changePic(item,index){
        this.changeAttrPic=true
        console.log(item,index)
        this.updatPic=true
        this.changePicObj=item.tierIndex[0]  
    },

    

    deleteImg(index){
        //  this.$set(this.ruleForm.images,index,'')
         this.ruleForm.images.splice(index,1)
    },
    vkfb(item,index){
         console.log(item)
         item.checked02=true
         this.$set(this.ruleForm.tiers,index,item)  
    },

    onhv(item,index,index02){
        item.checked02=true
        
        this.$set(this.ruleForm.tiers[index],index02,item)  
    },

    fixAttr(item,index,index02){
        console.log(item,index,index02)
        item.checked02=false

        this.ruleForm.tiers[index].optionArray[index02]=item.name
        this.ruleForm.tiers[index].listItem[index02].name=item.name
        this.ruleForm.tiers[index].listItem[index02].checked02=false
        this.$set(this.ruleForm.tiers,index,this.ruleForm.tiers[index])  

         console.log(this.ruleForm.tiers)
        this.itemKey=Math.random()
    },

    confirmvkfb(item,index){
         console.log(item,index)
         item.checked02=false
         this.$set(this.ruleForm.tiers,index,item)  
    },

    goBack(){
        this.$router.push('/alliance/singleGoods')
    },


    

    showDelBtn(index){
        console.log(index)
        this.currentPage=index
        var e = document.createEvent("MouseEvents");
        e.initEvent("click", true, true);
        document.getElementById("initSlide").dispatchEvent(e);

    },
    hiddenDelBtn(){},
    deleImg(){},

    handlePictureSuccess(response, file, fileList){
        console.log('file',file)
    },

    getCurrentRow(item){
        console.log(item)
        this.pskuItem=item
    },

    banding(item,storeId){
        api
        .getStoreItemByGroup({
            itemSku:item,
            userId:this.userId
        })
        .then(res => {
            if(res.code === 200){
                console.log('仓库物品信息',res.data)

                if(res.data.length > 1 ){
                  res.data.forEach(p => {
                      p.storeItems.forEach(k => {
                          if(!p.image ){
                              p.image=p.storeItems[0].image
                          }
                      })
                  })
                  this.tableList=res.data
                  this.dialogVisible=true
         
                    return
                }
                let num=0
                if(res.data.length ==1){
                    if(!this.ruleForm.variations.length){
                        this.ruleForm.groupId=res.data[0].groupId
                    }
                    if(this.ruleForm.variations.length>0){
                        this.ruleForm.groupId=res.data[0].groupId
                        this.ruleForm.variations.forEach((k,index) => {
                            k.cusCode=null
                            let options=res.data[0].storeItems.map(p => {
                                return {
                                    value:p.cusCode,
                                    label:p.skuName
                                }
                            })
                            options.unshift({
                                label:this.$t("other.a140"),
                                value:null
                            })
                            this.$set(k,'options',options)
                            
                            res.data[0].storeItems.forEach(j => {
                                if(j.skuName == k.variationSku){
                                    k.cusCode=j.cusCode
                                } 
                            })

                            if(!k.cusCode){
                                k.cusCode=this.$t('other.a1319')
                            }
                            if(k.cusCode ==this.$t('other.a1319')){
                                num +=1
                            }
                          
                        })
                           
                    }
                }

                if(num){
                    let desc=this.$t('other.a1320')+num+this.$t('other.a1321')
                        this.$confirm(desc,this.$t("other.a142"),{
                            confirmButtonText:this.$t("other.a884"),
                            cancelButtonText: this.$t('other.a146'),
                            type: 'warning'
                        }).then(() => {
                           
                        })
                }

                console.log(this.ruleForm)
                
            }
        })
    },

    handleByuser(){
        this.wareOptions=[]
        this.dialogVisible=true

        let warehouseList=JSON.parse(localStorage.getItem('userInfo')).stores.filter(p => {return p.isUsed ==true})
        console.log('warehouseList',warehouseList)
        warehouseList.forEach(p => {
            this.wareOptions.push({
                label:p.storeName,
                value:p.storeId
            })
        })

        console.log(warehouseList)

        this.storeValue=warehouseList[0].storeId
        
        this.getStoreItem()
    },

    getStoreItem(){
        this.getDataList.storeId=this.storeValue
        this.getDataList.component=this.singleValue
        userStoreItemsApi
        .getStoreItem(this.getDataList)
        .then(res => {
            if(res.code === 200) {
                console.log('获取用户模版信息',res.data)
                res.data.groups.forEach(p => {
                    p.checked=false
                    if(!p.image){
                        p.image=p.storeItems[0].image
                    }
                })
                this.tableList=res.data.groups
                this.tableCount=res.data.count
            }
        })
    },

    submitPsku(){

        console.log(this.pskuItem)
        console.log(this.ruleForm)
        this.ruleForm.itemSku=this.pskuItem.itemSku
        if(!this.ruleForm.variations || this.ruleForm.variations.length == 0){//单规格 

        }else{//多规格 
             this.dialogVisible=false
                this.ruleForm.groupId=this.pskuItem.groupId
                let num=0
                this.ruleForm.variations.forEach((k,index) => {
                    k.cusCode=null
                    let options=[{
                        label:this.$t("other.a140"),
                        value:null
                    }]
                    this.pskuItem.storeItems.forEach(p => {
                        options.push({
                            value:p.cusCode,
                            label:p.skuName ? p.skuName : this.$t('other.a1322')
                        }) 
                    })
                 
                    this.$set(k,'options',options)
                    
                    this.pskuItem.storeItems.forEach(j => {
                        if(j.skuName == k.variationSku){
                            k.cusCode=j.cusCode
                        } 
                    })

                    if(!k.cusCode){
                        k.cusCode=null
                    }
                    if(!k.cusCode ){
                        num +=1
                    }
                    
                })
        }
       
    },

    getWaterImg(params){
        
        api
        .getWaterImg({
            userId:this.userId
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.waterDialog = true
        this.imgList=res.data
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    randomNum(){

        let arr=JSON.parse(JSON.stringify(this.ruleForm.images))
            for(var i=0,len=arr.length;i<len;i++){
                    var a=parseInt(Math.random()*len);
                    var temp=arr[a];
                    arr[a]=arr[i];
                    arr[i]=temp;
                
            }
            for(var i=0,len=arr.length;i<len;i++){
                
                    arr[i].positions=i;
                    arr[i].label="image"+ i;
                
            }
            this.ruleForm.images=arr
            console.log('arr',arr)
       
    },

    uploaWaterImg(params){

        console.log(params)
        const _file=params.file
        const isLt2M=_file.size/1024/1024 < 2

        let formData=new FormData()
        formData.append('file',_file)
        

      
        console.log('formData',formData)

        api
        .uploadImg(formData)
        .then(res => {
            if(res.code === 200){
                console.log(res.data)
                this.imgList.push({
                    watermarkUrl:res.data,
                    userId:this.userId
                })
                api
                .uploadWaterImg({
                    watermarkUrl:res.data,
                    userId:this.userId,
                    isUsed:true
                })
                .then(res => {
                    if(res.code === 200){
                        console.log('水印上传成功',res.data)
                    
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
                
            }else{
                this.$message.warning(res.msg)
            }
        })
    },

    handleUploadHttpRequest(params){
        console.log(params)
        const _file=params.file
        const isLt2M=_file.size/1024/1024 < 2

        let formData=new FormData()
        formData.append('file',_file)
        formData.append('shopId',JSON.parse(localStorage.getItem('userInfo')).shopeeShops[0].shopId)
        formData.append('isUploadToShopee',true)

        if(!isLt2M){
            this.$message.error(this.$t("other.a332"));
            return false;
        }

        console.log('formData',formData)

        api
        .uploadImg(formData)
        .then(res => {
            if(res.code === 200){
                console.log(res.data)
                this.imageUrl = res.data.image_info_list[0].image_info.image_url_list[0].image_url
                let IMGID = res.data.image_info_list[0].image_info.image_id
                if(!this.changeAttrPic){

                    let num=this.ruleForm.images.length+1
                    this.ruleForm.images.push({
                        image:this.imageUrl,
                        positions:num,
                        productId:null,
                        itemId:null,
                         imageId: IMGID
                    })
    
                    console.log(this.ruleForm)
                }

            }else{
                this.$message.warning(res.msg)
            }
        })
    },

    //shopee采集过来的商品，编辑时调用此方法
    scrapedDataByshopee(data){
         this.ruleForm=data
         this.tierVariations=[]
             if(data.tiers.length){
                //属性分类
                this.tierVariations=data.tiers.map(p => {
                    return {
                        name:p.name,
                        tierVariations:'',
                        firstCategory:'',
                        optionArray:p.optionArray.map(i => {
                            return {
                                name:i,
                                checked:true,
                                checked02:false
                            }
                        })
                    }
                })

                this.ruleForm.variations.forEach((p,index) => {
                    p.firstName=this.tierVariations[0].optionArray[p.tierIndex[0]].name
                    if(data.tiers.length > 1){
                        p.secondName=this.tierVariations[1].optionArray[p.tierIndex[1]].name
                    }
                })
            }

             if(this.ModelData.variations.length > 0){//多规格
                this.radio='2'
            }else{//单品
                this.radio='1'
            }
           
    },

    getUserCache(){
        utils.getInfoByCache({
            userId:this.userId,
            cacheKey:'productModel'
        }).then(res => {
            if(res){
                this.userInfoProduct=res
            }
            console.log('用户保存的模版',res)
        })
    },
    init(){
        for(let i=0;i<9;i++){
            this.ruleForm.images.push({
                image:'',
                positions:i
            })
        }
        this.countryOption=utils.getCountryOption()
       

         if(this.$route.query.addOthers){//新增商品
          this.getShop()
          this.ModelData.status=null
          this.addOthers=true
          this.ModelData.condition="NEW"
          this.ModelData.tiers.forEach(k => {
            k.checked02=false
            k.listItem=k.optionArray.map(k => {
                return {
                    name:k,
                    checked02:false
                }
            })
          })
           this.scrapedDataByshopee(this.ModelData)
           
        }

        if(this.$route.query.productId){//编辑
         this.addOthers=true
         this.ModelData.tiers.forEach(k => {
                k.checked02=false
                k.listItem=k.optionArray.map(k => {
                    return {
                        name:k,
                        checked02:false
                    }
                })
            })
            console.log(this.$route.query.productId)
           
            console.log('model',this.ModelData)


            const code={
                'TH':this.$t('other.a1305'),
                'PH':this.$t('other.a1306'),
                'ID':this.$t('other.a1307'),
                'MY':this.$t('other.a1308'),
                'TW':this.$t('other.a1309'),
                'VN':this.$t('other.a1310'),
            }

            this.ruleForm=this.ModelData
            if(this.ModelData.variations.length > 0){//多规格
                this.radio='2'
            }else{//单品
                this.radio='1'
            }
            console.log('ModelData',this.ruleForm)

            this.active=2
            this.sitelist=[{
                label:this.$t('other.a1294'),
                value:'ROOT'
            },{
                label:this.$t('other.a1295'),
                value:'DXS'
            }]
            this.sitelist.push({
                label:code[this.ModelData.country 
                ] + this.ModelData.productId,
                value:this.ModelData.country,
            })
            this.counstSite=[{
                country:'ROOT',
                value:this.ModelData
            }]
            this.counstSite.push(this.ModelData)
             console.log('ModelData',this.ModelData)
             console.log('counstSite',this.counstSite)

             
           
        }

        if(this.$route.query.itemId){//线上导入
              let itemId=this.$route.query.itemId
                if(itemId !== undefined){
                    api
                    .getItemAttribute({itemId})
                    .then(res => {
                    if(res.code === 200) {
                        console.log('itemId',res.data)
                        this.ruleForm.categoryId=res.data.item.categoryId
                        this.ruleForm.name=res.data.item.name
                        this.ruleForm.packageHeight=res.data.item.packageHeight
                        this.ruleForm.packageLength=res.data.item.packageLength
                        this.ruleForm.packageWidth=res.data.item.packageWidth
                        this.ruleForm.itemId=res.data.item.itemId
                        this.ruleForm.hasVariation=res.data.item.hasVariation
                        this.ruleForm.cusCode=res.data.item.cusCode
                        this.ruleForm.shopee=res.data.item.shopee
                        this.ruleForm.sales=res.data.item.sales
                        this.ruleForm.condition='NEW'
                        this.ruleForm.itemSku=res.data.item.itemSku
                        this.ruleForm.weight=res.data.item.weight
                        this.ruleForm.description=res.data.item.description
                        res.data.images.forEach(p => {
                            this.ruleForm.images[p.positions].image=p.image
                        })
                        this.ruleForm.variations=[]

                        if(res.data.item.hasVariation && res.data.item.variations !== null){//如果有variations,多规格
                            this.radio="2"
                            this.ruleForm.hasVariation=true
                                res.data.item.variations.forEach(p =>{
                                    this.ruleForm.variations.push({
                                        name:p.name,
                                        price:p.price,
                                        stock:p.stock,
                                        variationSku:p.variationSku
                                    })
                            })
                        }else{//单品
                            this.radio="1"
                            this.ruleForm.hasVariation=false
                            this.ruleForm.stock=res.data.item.stock,
                            this.ruleForm.price=res.data.item.price,
                            this.ruleForm.itemSku=res.data.item.itemSku
                     
                        }
                        this.ruleForm.logistics=res.data.logistics
                        console.log('tt',this.ruleForm)
                    
                    }
                })
                }
        }

        // 代理商发布商品
        
        if(this.$route.query.id){
            this.fabuProduct=true
            this.getShop()
            api
            .getProductByproductId({
                productId:this.$route.query.id
            })
            .then(res => {
                if(res.code === 200){
                    let storeItems=JSON.parse(localStorage.getItem('storeItems'))
                    console.log('1111',res.data)
                    if(storeItems){
                        res.data.variations.forEach(p => {
                            p.options=storeItems
                        })
                    }
                    console.log(res.data)

                    
                    res.data.tiers[0].optionArray=[]
                    res.data.productShops=[]

                    res.data.condition='NEW'
                    res.data.country="ROOT"
                    res.data.productId=null
                    res.data.items=[]
                    res.data.itemSku=utils.randomString(12)
                    res.data.variations.sort((a,b) => {
                        return a.tierIndex[0]-b.tierIndex[0]
                    })
                    res.data.variations.forEach(p => {
                        res.data.tiers[0].optionArray.push(p.variationSku)
                        let ttp=p.options.find(item => item.label == p.variationSku)
                        p.cost='供货价：￥'+ p.price 
                        p.costCopy='供货价：￥'+ p.price 
                        p.supplyPrice=p.price 
                        p.price=null
                        p.cusCode=ttp ? ttp.value : p.cusCode,
                        p.variationSku=p.variationSku + '_'+ utils.randomString(6)
                    })

                    
                    res.data.tiers.forEach(k => {
                        k.checked02=false
                        k.listItem=k.optionArray.map(k => {
                            return {
                                name:k,
                                checked02:false
                            }
                        })
                    })
                    res.data.userId=this.userId
                    if(res.data.tiers[0].images == null){
                        res.data.tiers[0].images=[]
                    }




                    console.log('ruleform',res.data)
                    this.ruleForm=res.data
                    this.radio="2"

                    this.updataRuleform()

                    // console.log(this.ruleForm.children)
                    // if(this.ruleForm.children.length > 0)
                    // this.ruleForm.children.forEach(p => {
                    //     p.productShops[0].createTime=utils.getCurrnetTime(p.productShops[0].createTime)
                    // })
                    // this.publishFailed=JSON.parse(JSON.stringify(this.ruleForm.children))

                  

                    // console.log('publishFailed',this.publishFailed)
                }
            })
        }

      
    },

    //控制每页显示订单条数
    handleSizeChangeStore(val) {
                        console.log(`每页 ${val} 条`);
                        this.offset=parseInt(`${val}`)
                        this.getDataList.offset=parseInt(`${val}`)
                        this.handleCurrentChangeStore()
        },
        //显示当前第几页
        handleCurrentChangeStore(val) {
                this.radio2=null
                this.currentPage4=parseInt(`${val}`)
                this.getDataList.page=(parseInt(`${val}`) -1) * this.getDataList.offset
               

                this.getStoreItem()
                    
        },

        search(){
            this.radio2=null
            this.getDataList.cusCode=this.searchCuscode
            this.getStoreItem()
        }
    
}
}

</script>

<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.productionModel{
    background-color: #eee;
    box-sizing: border-box;
    padding: 80px 20px 30px 20px;

    .ionkjg{
        font-size: 18px;
        font-weight: bold;
        color: #909399;
        margin-left: 30px;
    }

    .jkgiong{
        margin-right: 30px;
    }

    .okntk{
        position: relative;
    }

    .mhbm{
        position: absolute;
        right: 20px;
        top: 0;
        color: #909399;
    }

    .ifnk{
        display: inline-block;
        width: 15px;
        border-radius: 2px;
        height: 15px;
        background-color: aquamarine;
        margin-right: 5px;
    }

    .ifnkCopy{
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 2px;
        background-color: red;
        margin-right: 5px;

    }

    .dklng{
        margin: 0 14px;
        font-size: 10px;
    }

    .rbjg{
         width: 100px;
        height: 100px;
        overflow: hidden;
        border: 1px solid #eee;
        text-align: center;
        line-height: 100px;
        font-size: 25px;
        cursor: pointer;
    }

    

    .okblf{
        position: relative;
        width: 100px;
        height: 100px;
        overflow: hidden;
        border: 1px solid #eee;
        text-align: center;

        img{
            width: 100%;
        }
    }

    .vlkbn{
        position: absolute;
        right: 0;
        bottom: 0;
        width: 100%;
        display: inline-block;
        text-align: center;
        color:#fff;
        font-size: 10px;
        background-color: #000;
        border: 1px solid #eee;
        cursor: pointer;
        
    }

    .tips{
        color: red;
        margin-bottom: 2px;
    }


    .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
    }
    .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;

    border: 1px solid #000;
    border-radius: 5px;
    }


    .avatar {
    width: 178px;
    height: 178px;
    display: block;
    }

    .ihbkg{
        width: 500px;
    }

    .ojkng{
        display: flex;
        flex-wrap: wrap;
    }

    .okting{
        margin-top: 20px;
    }

    .olkg{
        font-size: 14px;
        color: #606266;
        padding: 10px 5px;
    }
    

    .kvnnf{
        height: 20px!important;
        padding: 0 5px;
    }



    /deep/ .el-radio__inner{
        width: 20px;
        height: 20px;
    }

    .el-icon-edit{
        font-size: 18px;
        cursor: pointer;
    }

    .el-icon-check{
        font-weight: bold;
        font-size: 18px;
        color: #40d3f2;
        margin: 0 8px;
        cursor: pointer;
    }
    .icon-gouSolid-copy{
        font-size: 22px;
        margin:0 15px;
        color: rgb(42, 165, 21);

    }


       .footer{
            position: fixed;
            z-index: 15;
            background-color: #fff;
            left: 205px;
            width:90%;
            top: 50px;
            height: 50px;
            border-bottom:1px solid #eee;
           display: flex;
           justify-content: space-between;
           align-items: center;
          
            // display: flex;
            // justify-content: space-between;
            // align-items: center;
            // box-shadow:5px ​4px 23px -6px  #606266;
            
        }

    .basic_info{
       
        background-color: #fff;
        padding: 0  16px ;
        margin-bottom: 25px;

        /deep/.el-tabs__nav-scroll{
            display: flex;
            justify-content:center;
           
        }

        /deep/.el-tabs__item{
            font-size: 20px;
        }


        .attribute{
          
            min-width: 350px;
            box-sizing: border-box;
            // margin-bottom: 10px;
          

            .attribute_desc{
                display: inline-block;
               
                text-align: right;
            }
        }

        .title{
            height: 68px;
            line-height: 68px;
            font-size: 20px;
            font-weight: 500;
            letter-spacing: .02em!important;
            font-family: Roboto,sans-serif!important;
            border-bottom: 1px solid #eee;
        }

        .sined{
            display: flex;
        }

        .basic_detail{
            padding: 15px 0;


            .sined{
                display: flex;
            }

            .singSku_wrapper{
                display: flex;

                .singSku{
                display: flex;
                margin-right: 30px;

                .inputBox{
                    display: inline-block;
                    width: 180px;
                }
            }
            }

            .attribute{
                width:100%;
                height:auto;
               
                box-sizing: border-box;
                padding:5px 10px;


                .fist_title_wrapper{
                    border-bottom: 1px solid #eee;
                    display: flex;
                    justify-content: space-between;
                    .fist_title{
                    
                    font-weight: bold;
                    font-size: 18px;
                    
                }
                }

                .category_item{
                    margin: 0 15px;

                    .el-icon-circle-close{
                        font-weight: bold;
                        font-size: 18px;
                        color: red;
                        margin: 0 8px;
                        cursor: pointer;
                    }

                    .el-icon-edit{
                        cursor: pointer;
                    }


                    
                }

                .el-icon-edit{
                    padding: 0 10px;
                }

                

                


            }

            
        }

        .listitem{
            display: inline-block;
            width: 120px;
            height: 120px;
            border-radius: 3px;
            cursor: pointer;
            border: 1px dashed #c0ccda;
            margin: 15px 5px;
            position: relative;
        }

        .pic_desc{
            position: absolute;
            bottom: -45px;
            left: 40px;
        }

        .cateGory_wrapper{
            position: relative;
            box-shadow:0 5px 5px -3px #606266;
            height: 450px;
            
            

            
            .first_wrapper{
                position: absolute;
                top: 0;
                left: 0;
                width: 200px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;
               

                .first_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
                
            
            }

            

            .second_wrapper{
                position: absolute;
                top: 0;
                left: 200px;
                width: 200px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;
               

                .second_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
               

            }

            .three_wrapper{
                position: absolute;
                top: 0;
                left: 400px;
                width: 200px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                 .three_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
               

            }

            .four_wrapper{
                position: absolute;
                top: 0;
                left: 600px;
                width: 200px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                 .four_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
               

            }

            .five_wrapper{
                position: absolute;
                top: 0;
                left: 800px;
                width: 200px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                 .five_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
               

            }


            .category_title{
                position: relative;
                top: 0;
                left: 0;
               
            }

            .active{
                background-color: #fff;
            }

          

            .active:hover{
                background-color: #eee;
            }
        }

        .pic_box{
          
            width: 120px;
            height: 120px;
            position: absolute;
            z-index: 2;
        }

        .listitem::after {
            content: "+";
            font-size: 40px;
           
            position: absolute;
            top: 48px;
            left: 48px;
            z-index: 1;

          
        }

        .delete{
           
            width: 120px;
            background-color: rgba(0,0,0,.87);
            color: #fff;
            position: absolute;
            bottom: 0;
            left: 0;
            text-align: center;
            display: none;
            z-index:99

        }

        .deleteActive{
            display: block;
            z-index:99
        }

   

        .icon-zengjiatianjiajiajian{
            color: rgb(64, 211, 242);
            cursor: pointer;
            font-size: 20px;
        }

        .icon-jianshao1{
            color: rgb(246, 97, 109);
            cursor: pointer;
            font-size: 20px;
        }




     
    }
    .waterWrapper{
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            max-height: 300px;
            overflow-y: scroll;
            background-color: #eee;
        }


        .active{
            box-sizing: border-box;
            border: 3px solid #409EFF;
        }

        .waterProduct{
            width: 90px;
            height: 90px;
            overflow: hidden;
            margin:3px ;
            cursor: pointer;
            position: relative;
           


            .dexlet{
                position: absolute;
                right: 3px;
                top: 3px;
                width: 10px;
                height: 10px;
                text-align: center;
                line-height: 10px;
                background-color:#fff;
                padding: 5px;
                border-radius: 50px;
                color: #000;
            }

            img{
            width: 100%;
            }
        }

        .uploaImg{
            border: 1px solid #000;
            width: 90px;
            height: 90px;
            margin: 3px;
        }

        /deep/ .el-icon-plus{
            font-size: 25px;
           
        }

   
}
</style>